import React, { useRef, useEffect, useState } from 'react';
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Flex,
	Icon,
	Image,
	SimpleGrid,
	Stack,
	Tab,
	TabList,
	TabPanels,
	Tabs,
	Tag,
	TagLabel,
	Text,
	useToast
} from '@chakra-ui/react';
import { format, add, compareDesc, formatDistanceStrict } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { FormHandles } from '@unform/core';
import { FiTrash2 } from 'react-icons/fi';
import { v4 as uuid } from 'uuid';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { formatPrice } from '../../../utils/format';
import formatInputMoeda from '../../../utils/formatInputMoeda';
import formatPriceNumber from '../../../utils/formatPriceNumber';
import InputDate from '../../Inputs/InputDate';
import Input from '../../Inputs/Input';
import Alert from '../../Alert';
import ModalAddPagBaixa from '../ModalAddPagBaixa';

import {
	Container,
	Content,
	Header,
	TituloItem,
	Buttons,
	FormView,
	TabsView,
	TabDataBaixa,
	TabTotais,
	TabPagamento,
} from './styles';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { ParcelaDTO } from '../../../dtos/ParcelaDTO';
import { ClienteDTO } from '../../../dtos/ClienteDTO';
import { BaixaDTO } from '../../../dtos/BaixaDTO';
import { PayDTO } from '../../../dtos/PayDTO';
import ModalPagPix from '../ModalPagPix';

interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	titulos: FinJsonDTO[];
	setTitulosParaBaixa: (titulos: FinJsonDTO[]) => void;
	handleForm: () => Promise<void>;
}

// tr300 - 490
// tr400 - 450

const ModalTituloBaixa: React.FC<ModalParams> = ({
	onClose = () => { },
	isVisible,
	titulos,
	setTitulosParaBaixa,
	handleForm,
}) => {
	const { user, company } = useAuth();
	const toast = useToast();

	const formRef = useRef<FormHandles>(null);
	const formRefTotais = useRef<FormHandles>(null);

	const [visible, setVisible] = useState<boolean>(isVisible);
	const [tabIndex, setTabIndex] = useState(0);

	const [disabledTabTotal, setDisabledTabTotal] = useState(true);
	const [disabledTabPagamento, setDisabledTabPagamento] = useState(true);

	const [lancamentoJson, setLancamentoJson] = useState<any>({});
	const [titulosUpdate, setTitulosUpdate] = useState<FinJsonDTO[]>(titulos);

	const [auxParcelas, setAuxParcelas] = useState<ParcelaDTO[]>([]);

	const [parcelasCred, setParcelasCred] = useState<ParcelaDTO[]>([]);
	const [parcelasDeb, setParcelasDeb] = useState<ParcelaDTO[]>([]);
	const [editCredDeb, setEditCredDeb] = useState('X');

	const [beforeDesc, setBeforeDesc] = useState(0);
	const [beforeJuros, setBeforeJuros] = useState(0);
	const [beforeMulta, setBeforeMulta] = useState(0);

	const [baixa, setBaixa] = useState({
		data: '',
		qtd_parcelas: 0, 
		vlr_baixa: 0, 
		vlr_desconto: 0, 
		vlr_multa: 0, 
		vlr_juros: 0, 
		total: 0, 
		vlr_receber: 0
	});

	const [params, setParams] = useState<any>();
	const [payRateio, setPayRateio] = useState<any>();
	const [caixaRateio, setCaixaRateio] = useState<any>();
	const [dataBaixa, setDataBaixa] = useState(format(new Date(), "Y'-'MM'-'dd", { locale: ptBR }));

	const [totalCred, setTotalCred] = useState({
		qtd_parc: 0, baixa: 0, desconto: 0, multa: 0, juros: 0, total: 0, total_atual: 0, receber: 0, pago: 0	
	});
	const [totalDeb, setTotalDeb] = useState({
		qtd_parc: 0, baixa: 0, desconto: 0, multa: 0, juros: 0, total: 0, total_atual: 0, receber: 0, pago: 0
	});
	const [totais, setTotais] = useState({
		qtd_parc: 0, baixa: 0, desconto: 0, multa: 0, juros: 0, total: 0, total_atual: 0, receber: 0
	});

	const [operacao, setOperacao] = useState("N");

	const [selectPays, setSelectPays] = useState<any[]>([]);
	const [selectTrocos, setSelectTrocos] = useState<any[]>([]);
	const [selectContas, setSelectContas] = useState<any[]>([]);
	const [pagamentos, setPagamentos] = useState<any[]>([]);

	const [trocos, setTrocos] = useState<any[]>([]);
	const [falta, setFalta] = useState(baixa.vlr_receber);
	const [troco, setTroco] = useState(0);

	const [modalAddPagBaixaVisible, setModalAddPagBaixaVisible] = useState(false);
	const [openAlert, setOpenAlert] = useState(false);
	const [textAlert, setTextAlert] = useState({ header: '', body: '', is_toast: false });

	const [modalPagPixVisible, setModalPagPixVisible] = useState(false);
	const [pixParams, setPixParams] = useState({} as any);

	// BUSCA AS CONFIGURAÇÕES DA BAIXA E INICIA O LANÇAMENTO
	async function fetchBaixaConfig() {
		try {
			const auxTitulosParaBaixa = titulosUpdate;

			// PEGA AS CONTAS DOS TÍTULOS AS SEREM BAIXADOS
			titulosUpdate.forEach((tituloCurrent) => {
				let total = 0;

				// 	FOR PARA CALCULAR O VALOR TOTAL DAS PARCELAS.
				tituloCurrent.parcelas.forEach((parcelaCurrent) => {
					total = total + (parcelaCurrent.vlr_cred ? parcelaCurrent.vlr_cred : parcelaCurrent.vlr_deb);
				});
				//

				let aux_total_parcs = { total, total_formatted: formatPrice(total) };
				tituloCurrent.aux_total_parcs = aux_total_parcs;
			});
			//

			setTitulosUpdate([...auxTitulosParaBaixa]);

			const { data } = await api.get('/portal/financeiro/baixaconf');

			console.log('contas ==> ', data);

			setParams({ ...data.params });
			setSelectPays([...data.forma_pag]);
			setSelectTrocos([...data.forma_troco]);
			setSelectContas([...data.contas]);
			setPayRateio({ ...data.pay_rateio });
			setCaixaRateio({ ...data.caixa_rateio });

			console.log('baixa contas ==> ', data.contas);
		
			const auxLancamentoJson = {
				id: uuid(),
				id_emp: company.id,
				user_id: user.id,
				user_nome: user.nome,
				doc: auxTitulosParaBaixa[0].doc,
				data: '',
				obs: '',
				recorrencia: {
					ativo: false
				},
				operacao: {
					id: 3,
					nome: 'Caixa',
					titulo: false,
					type_id: 13,
					type_nome: 'Liquidação Cobrança'
				},
				documentos: [] as any,
				lancamentos: [] as any,
				vlr_doc: 0
			};

			setLancamentoJson(auxLancamentoJson);

		} catch (error) {
			console.log('Error ==> ', error);
		}
	};

	// PARA COLOCAR OS NOMES DOS CLIENTES NOS LANÇAMENTOS
	async function editClienteLancamento() {
		const auxTitulosParaBaixa = titulosUpdate;
		const clientes = [] as ClienteDTO[];

		auxTitulosParaBaixa.forEach((tituloCurrent) => {
			const indexCliente = clientes.findIndex(item => item.id === tituloCurrent.cliente.id);

			if (indexCliente < 0) {
				clientes.push(tituloCurrent.cliente);
			}
		});

		let name_cliente = '';

		clientes.forEach((clienteCurrent) => {
			const nomes = clienteCurrent.nome.split(' ');
			const nome = nomes.length > 1 ? `${nomes[0]} ${nomes[1]}` : `${nomes[0]}`;
			name_cliente = name_cliente === '' ? `${nome}` : `${name_cliente}, ${nome}`;
		});

		const auxLancamentoJson = lancamentoJson;
		auxLancamentoJson.cliente = {
			id: clientes.length > 1 ? '0' : clientes[0].id,
			nome: name_cliente,
			doc: clientes.length > 1 ? '' : clientes[0].doc,
			phone: clientes.length > 1 ? '' : clientes[0].phone,
		};

		setLancamentoJson(auxLancamentoJson);
		await addBaixasInTitulos();
	};

	// ADICIONA AS BAIXAS NOS TITULOS
	async function addBaixasInTitulos() {
		const auxTitulosParaBaixa = titulosUpdate;
		let auxTitulosUpdate: FinJsonDTO[] = [];

		auxTitulosParaBaixa.forEach((tituloCurrent) => {
			const auxBaixas = tituloCurrent.baixas || [] as BaixaDTO[];

			tituloCurrent.parcelas.forEach((parcelaCurrent) => {
				const indexBaixa = auxBaixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

				// VERIFICA SE A PARCELA FOI BAIXADA, SE SIM ADICIONA A BAIXA, SE NÃO EXCLUIR JUROS, MULTA E DESCONTO;
				// VERIFICA TAMBÉM SE A BAIXA EXITE SE EXISTIR NÃO INCLUI
				if (indexBaixa === -1) {
					// if (parcelaCurrent.amortizado > 0 && indexBaixa === -1) {

					// const auxValor = parcelaCurrent.saldo_cred > 0 ? parcelaCurrent.saldo_cred : parcelaCurrent.saldo_deb;
					// if (parcelaCurrent.amortizado >= auxValor) {
					const baixa: BaixaDTO = {
						id: uuid(),
						ativa: false,
						data: dataBaixa,
						desconto: parcelaCurrent.desconto,
						id_lancamento: lancamentoJson.id,
						id_parcela: parcelaCurrent.id,
						juros: parcelaCurrent.juros,
						multa: parcelaCurrent.multa,
						outra_desp: 0,
						parcela: parcelaCurrent.parcela,
						pay: [],
						pontualidade: 0,
						taxa_antecip: parcelaCurrent.taxa_antecip || 0,
						taxa_card: parcelaCurrent.taxa_card || 0,
						user_id: 0,
						user_nome: user.nome,

						amortizado: parcelaCurrent.saldo_cred > 0 ? parcelaCurrent.saldo_cred : parcelaCurrent.saldo_deb,

						vlr_cred: parcelaCurrent.saldo_cred,
						vlr_deb: parcelaCurrent.saldo_deb,

						vlr_pago_cred: parcelaCurrent.saldo_cred > 0 ? parcelaCurrent.saldo_cred : 0,
						vlr_pago_deb: parcelaCurrent.saldo_deb > 0 ? parcelaCurrent.saldo_deb : 0,
					};

					auxBaixas.push(baixa);
					//}
				 } /* else {
					parcelaCurrent.baixado = false;
					parcelaCurrent.desconto = 0;
					parcelaCurrent.juros = 0;
					parcelaCurrent.multa = 0;
				} */
			});

			tituloCurrent.baixas = auxBaixas;
			auxTitulosUpdate.push(tituloCurrent);
		});

		setTitulosUpdate([...auxTitulosUpdate]);
	};

	// SEPARA AS PARCELAS A SEREM PAGAS DEPENDENDO DA OPERAÇÃO
	async function sortTitulosParcelasBaixa() {
		const auxParcelasCred = [] as ParcelaDTO[];
		const auxParcelasDeb = [] as ParcelaDTO[];

		let aux_Parcelas = [] as ParcelaDTO[];
		let soma_saldo_cred = 0, soma_saldo_deb = 0;

		// titulosUpdate.forEach((tituloCurrent) => {
		for (let i = 0; i < titulosUpdate.length; i++) {
			const tituloCurrent = titulosUpdate[i];

			// tituloCurrent.parcelas.forEach((parcelaCurrent) => {
			for (let j = 0; j < tituloCurrent.parcelas.length; j++) {
				const parcelaCurrent = tituloCurrent.parcelas[j];

				const indexBaixa = tituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

				parcelaCurrent.vlr_cred > 0 ? auxParcelasCred.push(parcelaCurrent) : auxParcelasDeb.push(parcelaCurrent);

				if (indexBaixa !== -1) {
					const baixaCurrent = tituloCurrent.baixas[indexBaixa];
					aux_Parcelas.push(parcelaCurrent);

					if (baixaCurrent.vlr_cred > 0) {
						soma_saldo_cred += baixaCurrent.vlr_cred + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
					} else {
						soma_saldo_deb += baixaCurrent.vlr_deb + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
					}
				}
			};
		};

		setParcelasCred([...auxParcelasCred]);
		setParcelasDeb([...auxParcelasDeb]);

		const auxOperacao = soma_saldo_cred === soma_saldo_deb ? 'N' : soma_saldo_cred > soma_saldo_deb ? 'C' : 'D';
		setOperacao(auxOperacao);
		setEditCredDeb(soma_saldo_cred === 0 || soma_saldo_deb === 0 ? 'X' : auxOperacao);

		const auxParcs = [] as ParcelaDTO[];

		// aux_Parcelas.forEach((parcelaCurrent) => {
		for (let i = 0; i < aux_Parcelas.length; i++) {
			const parcelaCurrent = aux_Parcelas[i];

			if (soma_saldo_cred > soma_saldo_deb) {
				if (parcelaCurrent.saldo_cred > 0) {
					auxParcs.push(parcelaCurrent);
				};
			} else {
				if (parcelaCurrent.saldo_deb > 0) {
					auxParcs.push(parcelaCurrent);
				};
			};
		};

		if (soma_saldo_cred > soma_saldo_deb) {
			auxParcs.sort((a, b) => a.saldo_cred - b.saldo_cred);
		} else {
			auxParcs.sort((a, b) => a.saldo_deb - b.saldo_deb);
		};

		setAuxParcelas([...auxParcs]);
	};

	useEffect(() => {
		fetchBaixaConfig();
		editClienteLancamento();
		// sortTitulosParcelas();
	}, []);

	useEffect(() => {
		somaTotaisCredDebForm(editCredDeb);
	}, [editCredDeb]);

	// FAZ AS SOMAS DOS TOTAIS DE BAIXA, JUROS, MULTA, DESCONTO, TOTAL E VALOR RECEBER E EDITA O FORM
	async function somaTotaisCredDebForm(verifCredDeb: string) {
		let totalJuros = 0, totalMulta = 0, totalDesc = 0;
		let totalBaixa = 0, total = 0;

		for (let i = 0; i < titulosUpdate.length; i++) {
			const tituloCurrent = titulosUpdate[i];

			if (verifCredDeb === 'C') {
				for (let j = 0; j < parcelasCred.length; j++) {
					const parcelaCurrent = parcelasCred[j];
					const indexBaixa = tituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

					if (indexBaixa !== -1) {
						const baixaCurrent = tituloCurrent.baixas[indexBaixa];
						totalJuros += baixaCurrent.juros;
						totalMulta += baixaCurrent.multa;
						totalDesc += baixaCurrent.desconto;
						totalBaixa += parcelaCurrent.saldo_cred; // baixaCurrent.vlr_cred;
						total += baixaCurrent.vlr_cred + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
					}
				}

				formRefTotais.current?.setFieldValue('qtd_parcelas', parcelasCred.length);
			} else {
				for (let j = 0; j < parcelasDeb.length; j++) {
					const parcelaCurrent = parcelasDeb[j];
					const indexBaixa = tituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

					if (indexBaixa !== -1) {
						const baixaCurrent = tituloCurrent.baixas[indexBaixa];
						totalJuros += baixaCurrent.juros;
						totalMulta += baixaCurrent.multa;
						totalDesc += baixaCurrent.desconto;
						totalBaixa += parcelaCurrent.saldo_deb; // baixaCurrent.vlr_deb;
						total += baixaCurrent.vlr_deb + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
					}
				}

				formRefTotais.current?.setFieldValue('qtd_parcelas', parcelasDeb.length);
			}
		};

		formRefTotais.current?.setFieldValue('vlr_baixa', formatPrice(totalBaixa));
		formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(totalDesc));
		formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(totalMulta));
		formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(totalJuros));
		formRefTotais.current?.setFieldValue('total', formatPrice(total));
		formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(total));
	};

	// CALCULA JUROS, MULTA, DESCONTO CONFORME OS PARAMETROS (PARAMS)
	async function calculaJurosMultaDesconto() {
		const auxTitulosParaBaixa = titulosUpdate;
		let parcelasTotaisSaldo = 0;

		// auxTitulosParaBaixa.forEach((tituloCurrent) => {
		for (let i = 0; i < titulosUpdate.length; i++) {
			const tituloCurrent = titulosUpdate[i];

			let aux_totais = {
				juros: 0,
				multa: 0,
				desconto: 0,
				qtd_parc: 0,
				baixa: 0,
				total: 0,
			};

			// tituloCurrent.parcelas.forEach((parcelaCurrent) => {
			for (let j = 0; j < tituloCurrent.parcelas.length; j++) {
				const parcelaCurrent = tituloCurrent.parcelas[j];

				let aux_parcela_totais = {
					juros: 0,
					multa: 0,
					data_baixa: dataBaixa,
					desconto: 0,
					saldo: parcelaCurrent.saldo_cred > 0 ? parcelaCurrent.saldo_cred : parcelaCurrent.saldo_deb,
				};

				parcelasTotaisSaldo = parcelasTotaisSaldo + aux_parcela_totais.saldo;

				// VERIFICA O VENCIMENTO DA PARCELA, -1 VENCIDO, 0 NO DIA, 1 ADIANTADO
				const verifyVencimento = compareDesc(
					new Date(dataBaixa),
					add(new Date(parcelaCurrent.vencimento), { days: 1 })
				);
				//

				// ACHA AQUANTIDADE DE DIAS DE DIFERENÇA DO VENCIMENTO COM O DIA DE HOJE
				const distanceDays = Number(formatDistanceStrict(
					add(new Date(dataBaixa), { days: 1 }),
					add(new Date(parcelaCurrent.vencimento), { days: 1 }),
					{ unit: 'day', roundingMethod: 'round', addSuffix: false }).replace(' days', '')
				);

				const indexBaixa = tituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

				if (indexBaixa !== -1) {
					tituloCurrent.baixas[indexBaixa].pontualidade = distanceDays * (verifyVencimento * -1);
				}

				if (verifyVencimento === -1) {
					// const valor = aux_parcela.vlr_cred > 0 ? aux_parcela.vlr_cred : aux_parcela.vlr_deb;
					// const valor = aux_parcela.saldo_cred > 0 ? aux_parcela.saldo_cred : aux_parcela.saldo_deb;
					const valor = aux_parcela_totais.saldo;

					// JUROS //
					let taxaJuros = 0;
					let jurosCalculado = 0;

					if (parcelaCurrent.saldo_deb > 0) {
						if (parcelaCurrent.boleto && parcelaCurrent.boleto.mora > 0) {
							taxaJuros = parcelaCurrent.boleto.mora;
							jurosCalculado = Number((taxaJuros * distanceDays).toFixed(2));
						};
					} else {
						if (distanceDays > params.juros_carencia) {
							if (parcelaCurrent.boleto && parcelaCurrent.boleto.mora > 0) {
								taxaJuros = parcelaCurrent.boleto.mora;
								jurosCalculado = Number((taxaJuros * distanceDays).toFixed(2));
							} else {
								taxaJuros = params.juros_perc / 30;
								jurosCalculado = Number(((valor * taxaJuros * distanceDays) / 30).toFixed(2));
							};
						};
					};

					parcelasTotaisSaldo = parcelasTotaisSaldo + jurosCalculado;

					aux_parcela_totais.juros = jurosCalculado;
					aux_totais.juros = Number((aux_totais.juros + jurosCalculado).toFixed(2));
					aux_totais.total = Number((aux_totais.total + jurosCalculado).toFixed(2));

					// MULTA //
					let taxaMulta = 0;
					let multaCalculado = 0;

					if (parcelaCurrent.saldo_deb > 0) {
						if (parcelaCurrent.boleto && parcelaCurrent.boleto.multa > 0) {
							taxaMulta = parcelaCurrent.boleto.multa;
							multaCalculado = taxaMulta;
						};
					} else {
						if (distanceDays > params.multa_carencia) {
							if (parcelaCurrent.boleto && parcelaCurrent.boleto.multa > 0) {
								taxaMulta = parcelaCurrent.boleto.multa;
								multaCalculado = taxaMulta;
							} else {
								taxaMulta = params.multa_perc / 100;
								multaCalculado = Number((valor * taxaMulta).toFixed(2));
							};
						};
					};

					parcelasTotaisSaldo = parcelasTotaisSaldo + multaCalculado;

					aux_parcela_totais.multa = Number(multaCalculado.toFixed(2));
					aux_totais.multa = aux_totais.multa + Number(multaCalculado.toFixed(2));
					aux_totais.total = aux_totais.total + Number(multaCalculado.toFixed(2));
				}
				else if (verifyVencimento === 1) {
					// const valor = parcelaCurrent.vlr_cred > 0 ? parcelaCurrent.vlr_cred : parcelaCurrent.vlr_deb;
					// const valor = parcelaCurrent.saldo_cred > 0 ? parcelaCurrent.saldo_cred : parcelaCurrent.saldo_deb;
					const valor = aux_parcela_totais.saldo;

					// DESCONTO //
					let taxaDesc = 0;
					let descCalculado = 0;

					if (parcelaCurrent.saldo_deb > 0) {
						if (parcelaCurrent.boleto && parcelaCurrent.boleto.desconto) {
							descCalculado = parcelaCurrent.boleto.desconto;
						};
					} else {
						if (distanceDays >= params.desc_ate_dias) {
							if (parcelaCurrent.boleto && parcelaCurrent.boleto.desconto) {
								descCalculado = parcelaCurrent.boleto.desconto;
							} else {
								taxaDesc = params.desc_perc / 100;
								descCalculado = Number((((valor * taxaDesc) / 30) * distanceDays).toFixed(2));
							};
						};
					};

					parcelasTotaisSaldo = parcelasTotaisSaldo - descCalculado;

					aux_parcela_totais.desconto = descCalculado;
					aux_totais.desconto = Number((aux_totais.desconto + descCalculado).toFixed(2));
					aux_totais.total = Number((aux_totais.total - descCalculado).toFixed(2));
				};

				parcelaCurrent.parcela_totais = aux_parcela_totais;
				tituloCurrent.aux_totais = aux_totais;
				// auxTitulosParaBaixa[i].parcelas[j] = parcelaCurrent;
			};

			setTitulosUpdate([...auxTitulosParaBaixa]);

			/* formRefTotais.current?.setFieldValue('total', formatPrice(parcelasTotaisSaldo));
			formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(parcelasTotaisSaldo));
			*/
		};
	};

	// CALCULA OS TOTAIS DE JUROS, MULTA E DESCONTO DE TODAS AS PARCELAS DO TITULOS
	async function calculaTotaisJurosMultaDesconto() {
		const auxTitulosParaBaixa = titulosUpdate;

		const totais = {
			cred: {
				qtd_parc: 0,
				baixa: 0,
				desconto: 0,
				multa: 0,
				juros: 0,
				total: 0,
				total_atual: 0,
				receber: 0,
				pago: 0,
			},
			deb: {
				qtd_parc: 0,
				baixa: 0,
				desconto: 0,
				multa: 0,
				juros: 0,
				total: 0,
				total_atual: 0,
				receber: 0,
				pago: 0,
			}
		};

		// auxTitulosParaBaixa.forEach((tituloCurrent) => {
		for (let i = 0; i < titulosUpdate.length; i++) {
			const tituloCurrent = titulosUpdate[i];

			const aux_totais = tituloCurrent.aux_totais;
			const aux_parcs = tituloCurrent.aux_total_parcs;

			const tipo_operacao = tituloCurrent.parcelas[0].saldo_cred > 0 ? 'cred' : 'deb';
			const total = totais[tipo_operacao];

			total.qtd_parc += tituloCurrent.parcelas.length;
			total.desconto += Number((aux_totais?.desconto || 0).toFixed(2));
			total.multa += Number((aux_totais?.multa || 0).toFixed(2));
			total.juros += Number((aux_totais?.juros || 0).toFixed(2));
			total.total += Number((aux_parcs?.total || 0).toFixed(2));
			total.total_atual += Number((aux_parcs?.total || 0).toFixed(2));

			// tituloCurrent.parcelas.forEach((parcelaCurrent) => {
			for (let j = 0; j < tituloCurrent.parcelas.length; j++) {
				const parcelaCurrent = tituloCurrent.parcelas[j];

				const auxJuros = parcelaCurrent.parcela_totais?.juros || 0;
				const auxMulta = parcelaCurrent.parcela_totais?.multa || 0;
				const auxDesconto = parcelaCurrent.parcela_totais?.desconto || 0;
				const auxSaldo = parcelaCurrent.parcela_totais?.saldo || 0;

				const indexBaixa = tituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

				if (indexBaixa !== -1) {
					tituloCurrent.baixas[indexBaixa].juros = auxJuros;
					tituloCurrent.baixas[indexBaixa].multa = auxMulta;
					tituloCurrent.baixas[indexBaixa].desconto = auxDesconto;
					tituloCurrent.baixas[indexBaixa].vlr_cred = tituloCurrent.baixas[indexBaixa].vlr_cred > 0 ? auxSaldo : 0;
					tituloCurrent.baixas[indexBaixa].vlr_deb = tituloCurrent.baixas[indexBaixa].vlr_deb > 0 ? auxSaldo : 0;
					tituloCurrent.baixas[indexBaixa].vlr_pago_cred = parcelaCurrent.vlr_cred > 0  ? Number((auxSaldo + auxJuros + auxMulta - auxDesconto).toFixed(2)) : 0;
					tituloCurrent.baixas[indexBaixa].vlr_pago_deb = parcelaCurrent.vlr_deb > 0 ? Number((auxSaldo + auxJuros + auxMulta - auxDesconto).toFixed(2)) : 0;
					tituloCurrent.baixas[indexBaixa].id_lancamento = lancamentoJson.id;

					parcelaCurrent.juros = auxJuros;
					parcelaCurrent.multa = auxMulta;
					parcelaCurrent.desconto = auxDesconto;
					parcelaCurrent.vlr_cred = parcelaCurrent.saldo_cred > 0 ? auxSaldo : 0;
					parcelaCurrent.vlr_deb = parcelaCurrent.saldo_deb > 0 ? auxSaldo : 0;
					parcelaCurrent.pago = Number((auxSaldo + auxJuros + auxMulta - auxDesconto).toFixed(2));

					tituloCurrent.parcelas[j] = parcelaCurrent;
				}

				const auxPago = Number((auxSaldo + auxJuros + auxMulta - auxDesconto).toFixed(2));

				total.pago += auxPago;
				total.receber += auxPago;
				total.baixa += Number((auxPago - auxJuros - auxMulta + auxDesconto).toFixed(2));
			};
		};

		if (editCredDeb === 'X') {
			formRefTotais.current?.setFieldValue('qtd_parcelas', totais.cred.qtd_parc + totais.deb.qtd_parc);
			formRefTotais.current?.setFieldValue('vlr_baixa', formatPrice(Math.abs(totais.cred.baixa - totais.deb.baixa)));
			formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(Math.abs(totais.cred.desconto - totais.deb.desconto)));
			formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(Math.abs(totais.cred.multa - totais.deb.multa)));
			formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(Math.abs(totais.cred.juros - totais.deb.juros)));
			formRefTotais.current?.setFieldValue('total', formatPrice(Math.abs(totais.cred.pago - totais.deb.pago)));
			formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(Math.abs(totais.cred.pago - totais.deb.pago)));
		}
		
		setTotalCred({ ...totais.cred });
		setTotalDeb({ ...totais.deb });
		setTotais({
			qtd_parc: totais.cred.qtd_parc + totais.deb.qtd_parc,
			baixa: Math.abs(totais.cred.baixa - totais.deb.baixa),
			desconto: Math.abs(totais.cred.desconto - totais.deb.desconto),
			multa: Math.abs(totais.cred.multa - totais.deb.multa),
			juros: Math.abs(totais.cred.juros - totais.deb.juros),
			total: Math.abs(totais.cred.pago - totais.deb.pago),
			total_atual: Math.abs(totais.cred.pago - totais.deb.pago),
			receber: Math.abs(totais.cred.pago - totais.deb.pago)
		});

		setBeforeDesc(Math.abs(totais.cred.desconto - totais.deb.desconto));

		setOperacao(totais.cred.pago === totais.deb.pago ? 'N' : totais.cred.pago > totais.deb.pago ? 'C' : 'D');

		setTitulosUpdate([...auxTitulosParaBaixa]);

		setDisabledTabTotal(false);
		setTabIndex(1);
	};

	// ALTERA AS BAIXAS QUE VÃO SER PAGAS COM PERMUTA
	async function payBaixasPermuta() {
		for (let i = 0; i < titulosUpdate.length; i++) {
			const tituloCurrent = titulosUpdate[i];

			for (let j = 0; j < tituloCurrent.baixas.length; j++) {
				const baixaCurrent = tituloCurrent.baixas[j];

				const indexParcela = auxParcelas.findIndex(parcela => parcela.id === baixaCurrent.id_parcela);
				const indexParcelaTitulo = tituloCurrent.parcelas.findIndex(parcela => parcela.id === baixaCurrent.id_parcela);

				if (indexParcela === -1 && indexParcelaTitulo !== -1) {
					baixaCurrent.vlr_pago_cred = baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_cred + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto : 0;
					baixaCurrent.vlr_pago_deb = baixaCurrent.vlr_deb > 0 ? baixaCurrent.vlr_deb + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto : 0;
					baixaCurrent.amortizado = baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_cred : baixaCurrent.vlr_deb;

					titulosUpdate[i].baixas[j] = baixaCurrent;
				}
			}
		}
	};

	// COPIA A LINHA DIGITAVEL DO BOLETO
	function handleCopy(codigo: string) {
		navigator.clipboard.writeText(codigo);

		toast({
			title: 'Linha Digitável.',
			description: `Copiado a linha ${codigo}`,
			status: 'info',
			duration: 3000,
			position: 'top-right',
			isClosable: true,
			containerStyle: {
				marginTop: '12'
			}
		})
	};

	// SUBMETE A TAB DE DATA DA BAIXA E PASSA PRA PROXIMA TAB
	async function handleSubmitTabDataBaixa() {
		setBaixa({ ...baixa, data: dataBaixa });

		await calculaJurosMultaDesconto();
		await calculaTotaisJurosMultaDesconto();

		await sortTitulosParcelasBaixa();
	};

	// EXCLUIR A PARCELA OU TITULO INTEIRO DA BAIXA
	function handleDeleteParcelaTitulo (id_parcela: string, id_titulo: string, exclude_titulo: boolean) {
		setDisabledTabTotal(true);
		setDisabledTabPagamento(true);
		
		const auxTitulosParaBaixa = titulos;
		const indexTitulo = auxTitulosParaBaixa.findIndex(item => item.id === id_titulo);

		setTotais({ ...totais,
			qtd_parc: 0, baixa: 0, desconto: 0, multa: 0, juros: 0, total: 0, total_atual: 0, receber: 0
		});

		if (!exclude_titulo) {
			if (auxTitulosParaBaixa[indexTitulo].parcelas.length === 1) {
				if (auxTitulosParaBaixa.length === 1) {
					handleCancel(true);
					return;
				};
				
				auxTitulosParaBaixa.splice(indexTitulo, 1);
				setTitulosUpdate([...auxTitulosParaBaixa]);
				setTitulosParaBaixa([...auxTitulosParaBaixa]);

				// SE EXISTIR PERMUTA EXCLUI PARA NÃO APARECER NA ABA PAGAMENTOS
				setLancamentoJson({ ...lancamentoJson, lancamentos: [] });
				//
				return;
			};

			const indexParcela = auxTitulosParaBaixa[indexTitulo].parcelas.findIndex(item => item.id === id_parcela);

			const aux_total_parcs = auxTitulosParaBaixa[indexTitulo].aux_total_parcs;
			const aux_totais = auxTitulosParaBaixa[indexTitulo].aux_totais;

			const parcela = auxTitulosParaBaixa[indexTitulo].parcelas[indexParcela];

			let valor = (parcela.vlr_cred ? parcela.vlr_cred : parcela.vlr_deb);

			if (aux_total_parcs) {
				aux_total_parcs.total = aux_total_parcs.total - valor;
				aux_total_parcs.total_formatted = formatPrice(aux_total_parcs.total);
				auxTitulosParaBaixa[indexTitulo].aux_total_parcs = aux_total_parcs;
			};
			if (aux_totais && parcela) {
				aux_totais.juros = aux_totais.juros - ((parcela && parcela.parcela_totais) ? parcela.parcela_totais.juros : 0);
				aux_totais.multa = aux_totais.multa - ((parcela && parcela.parcela_totais) ? parcela.parcela_totais.multa : 0);
				aux_totais.desconto = aux_totais.desconto - ((parcela && parcela.parcela_totais) ? parcela.parcela_totais.desconto : 0);
			};

			auxTitulosParaBaixa[indexTitulo].parcelas.splice(indexParcela, 1);
			setTitulosUpdate([...auxTitulosParaBaixa]);
			setTitulosParaBaixa([...auxTitulosParaBaixa]);

			// SE EXISTIR PERMUTA EXCLUI PARA NÃO APARECER NA ABA PAGAMENTOS
			setLancamentoJson({ ...lancamentoJson, lancamentos: [] });
			//
			return;
		};

		if (auxTitulosParaBaixa.length === 1) {
			handleCancel(true);
			return;
		};

		auxTitulosParaBaixa.splice(indexTitulo, 1);
		setTitulosUpdate([...auxTitulosParaBaixa]);
		setTitulosParaBaixa([...auxTitulosParaBaixa]);

		// SE EXISTIR PERMUTA EXCLUI PARA NÃO APARECER NA ABA PAGAMENTOS
		setLancamentoJson({ ...lancamentoJson, lancamentos: [] });
		//
	};

	// CALCULA QUANDO SAI DO CAMPO TOTAL
	async function onBlurTotal() {
		const inputBaixa = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_baixa'));
		const inputTotal = formatPriceNumber(formRefTotais.current?.getFieldValue('total'));
		let inputDesc = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_desconto'));
		let inputMulta = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_multa'));
		let inputJuros = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_juros'));

		formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(inputTotal));

		const somaTotal = Number((inputTotal - inputJuros - inputMulta + inputDesc).toFixed(2));

		if (somaTotal === totais.baixa) {
			return;
		};

		// setDisabledTabPagamento(true);

		// if (inputTotal < totais.baixa) {
			if (inputTotal < inputBaixa) {
			// const desc = Number((totais.baixa - inputTotal).toFixed(2));
			const desc = Number((inputBaixa - inputTotal).toFixed(2));
			formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(desc));
			formRefTotais.current?.setFieldValue('vlr_multa', 'R$ 0,00');
			formRefTotais.current?.setFieldValue('vlr_juros', 'R$ 0,00');
			setTotais({ ...totais, total_atual: inputTotal });

			await calculoBaixaParcial(formRefTotais.current?.getData());
			return;
		}
		// else if (inputTotal === totais.baixa) {
		else if (inputTotal === inputBaixa) {
			formRefTotais.current?.setFieldValue('vlr_desconto', 'R$ 0,00');
			formRefTotais.current?.setFieldValue('vlr_multa', 'R$ 0,00');
			formRefTotais.current?.setFieldValue('vlr_juros', 'R$ 0,00');
			setTotais({ ...totais, total_atual: inputTotal });

			await calculoBaixaParcial(formRefTotais.current?.getData());
			return;
		}
		else {
			const resto = Number((totais.total_atual - inputTotal).toFixed(2));

			// Aumentando o Total;
			if (resto < 0) {
				if (inputDesc > 0) {
					const sobra = Number((inputDesc - Math.abs(resto)).toFixed(2));

					if (sobra > 0){
						formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(sobra));
					} else {
						formRefTotais.current?.setFieldValue('vlr_desconto', 'R$ 0,00');

						if (inputMulta < totais.multa) {
							if (inputMulta < Math.abs(sobra) && Math.abs(sobra) < totais.multa) {
								const newMulta = Number((inputMulta + Math.abs(sobra)).toFixed(2));
								formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(newMulta));
							} else {
								const restoMulta = Number((Math.abs(sobra) - totais.multa).toFixed(2));
								formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(totais.multa));

								const newJuros = Number((restoMulta + inputJuros).toFixed(2));
								formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(newJuros));
							}
						} else {
							const newJuros = Number((inputJuros + Math.abs(sobra)).toFixed(2));
							formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(newJuros));
						};
					};
				} else {
					if (inputMulta < totais.multa) {
						if (inputMulta < Math.abs(resto)) {
							const newMulta = Number((inputMulta + Math.abs(resto)).toFixed(2));
							formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(newMulta));
						} else {
							const restoMulta = Number((inputMulta - Math.abs(resto)).toFixed(2));
							formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(totais.multa));

							const newJuros = Number((restoMulta + inputJuros).toFixed(2));
							formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(newJuros));
						}
					} else {
						const newJuros = Number((inputJuros + Math.abs(resto)).toFixed(2));
						formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(newJuros));
					};
				}
			}
			// Diminuindo o Total;
			else {
				if (inputJuros > 0) {
					const sobra = Number((inputJuros - resto).toFixed(2));

					if (sobra > 0) {
						formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(sobra));
					} else {
						formRefTotais.current?.setFieldValue('vlr_juros', 'R$ 0,00');

						if (inputMulta > 0) {
							const newMulta = Number((inputMulta - Math.abs(sobra)).toFixed(2));

							if (newMulta > 0) {
								formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(newMulta));
							} else {
								formRefTotais.current?.setFieldValue('vlr_multa', 'R$ 0,00');

								const newDesc = Number((inputDesc + Math.abs(newMulta)).toFixed(2));
								formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(newDesc));
							};
						} else {
							const newDesc = Number((inputDesc + Math.abs(sobra)).toFixed(2));
							formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(newDesc));
						};
					};
				} else {
					if (inputMulta > 0) {
						const newMulta = Number((inputMulta - resto).toFixed(2));

						if (newMulta > 0) {
							formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(newMulta));
						} else {
							formRefTotais.current?.setFieldValue('vlr_multa', 'R$ 0,00');

							const newDesc = Number((inputDesc + Math.abs(newMulta)).toFixed(2));
							formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(newDesc));
						};
					} else {
						const newDesc = Number((inputDesc +resto).toFixed(2));
						formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(newDesc));
					}
				};
			};

			setTotais({ ...totais, total_atual: inputTotal });
			// return;
		};

		await calculoBaixaParcial(formRefTotais.current?.getData());
	};

	// CALCULA QUANDO SAI DO CAMPO TOTAL MAS SEM CALCULAR MULTA
	async function onBlurTotalNotMulta() {
		const inputBaixa = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_baixa'));
		const inputTotal = formatPriceNumber(formRefTotais.current?.getFieldValue('total'));
		const inputDesc = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_desconto'));
		const inputMulta = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_multa'));
		const inputJuros = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_juros'));

		formRefTotais.current?.setFieldValue('vlr_receber', inputTotal);

		const somaTotal = Number((inputTotal - inputJuros - inputMulta + inputDesc).toFixed(2));

		if (somaTotal === totais.baixa) {
			return;
		};

		// setDisabledTabPagamento(true);

		// if (inputTotal < totais.baixa) {
		if (inputTotal < inputBaixa) {
			// const desc = Number((totais.baixa - inputTotal + totais.multa).toFixed(2));
			const desc = Number((inputBaixa - inputTotal + totais.multa).toFixed(2));
			formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(desc));
			formRefTotais.current?.setFieldValue('vlr_juros', 'R$ 0,00');
			setTotais({ ...totais, total_atual: inputTotal });

			await calculoBaixaParcial(formRefTotais.current?.getData());
			return;
		}
		// else if (inputTotal === totais.baixa) {
		else if (inputTotal === inputBaixa) {
			formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(totais.multa));
			formRefTotais.current?.setFieldValue('vlr_juros', 'R$ 0,00');
			setTotais({ ...totais, total_atual: inputTotal });

			await calculoBaixaParcial(formRefTotais.current?.getData());
			return;
		}
		else {
			const resto = Number((totais.total_atual - inputTotal).toFixed(2));

			// Aumentando o Total;
			if (resto < 0) {
				if (inputDesc > 0) {
					const sobra = Number((inputDesc - Math.abs(resto)).toFixed(2));

					if (sobra > 0) {
						formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(sobra));
					} else {
						formRefTotais.current?.setFieldValue('vlr_desconto', 'R$ 0,00');
					
						const newJuros = Number((inputJuros + Math.abs(sobra)).toFixed(2));
						formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(Math.abs(newJuros)));
					};
				} else {
					const newJuros = Number((inputJuros + Math.abs(resto)).toFixed(2));
					formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(newJuros));
				}
			} 
			// Diminuindo o Total;
			else {
				if (inputJuros > 0) {
					const sobra = Number((inputJuros - resto).toFixed(2));

					if (sobra > 0) {
						formRefTotais.current?.setFieldValue('vlr_juros', formatPrice(sobra));
					} else {
						formRefTotais.current?.setFieldValue('vlr_juros', 'R$ 0,00');

						const newDesc = Number((inputDesc + Math.abs(sobra)).toFixed(2));
						formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(newDesc));
					};
				} else {
					const newDesc = Number((inputDesc + resto + totais.multa).toFixed(2));
					formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(newDesc));
				};
			};

			setTotais({ ...totais, total_atual: inputTotal });
			// return;
		};

		await calculoBaixaParcial(formRefTotais.current?.getData());
	};

	// CALCULA QUANDO SAI DO CAMPO DESCONTO
	async function onBlurDesconto() {
		const inputBaixa = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_baixa'));
		// const inputTotal = formatPriceNumber(formRefTotais.current?.getFieldValue('total'));
		const inputDesc = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_desconto'));
		const inputMulta = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_multa'));
		const inputJuros = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_juros'));

		if (inputDesc === beforeDesc) {
			return;
		}

		let percDesc = 0

		if (editCredDeb === 'X') {
			percDesc = Number(((inputDesc * 100) / (totais.baixa + totais.multa + totais.juros)).toFixed(2));
		}
		else if (editCredDeb === 'C') {
			percDesc = Number(((inputDesc * 100) / (totalCred.baixa + totalCred.multa + totalCred.juros)).toFixed(2));
		}
		else {
			percDesc = Number(((inputDesc * 100) / (totalDeb.baixa + totalDeb.multa + totalDeb.juros)).toFixed(2));
		}

		if (percDesc <= params.desc_maximo) {
			// const newTotal = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			const newTotal = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

			// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

			setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

			// setDisabledTabPagamento(true);
		} else {
			if (params.desc_liberacao === 'N') {
				// const newTotal = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newTotal = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

				// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

				setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

				setDisabledTabPagamento(true);
			} else {
				formRefTotais.current?.setFieldValue('vlr_desconto', formatPrice(totais.desconto));

				// const newTotal = Number((totais.baixa + inputMulta + inputJuros - totais.desconto).toFixed(2));
				const newTotal = Number((inputBaixa + inputMulta + inputJuros - totais.desconto).toFixed(2));
				formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

				// const newReceber = Number((totais.baixa + inputMulta + inputJuros - totais.desconto).toFixed(2));
				const newReceber = Number((inputBaixa + inputMulta + inputJuros - totais.desconto).toFixed(2));
				formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

				setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

				// setDisabledTabPagamento(true);
			};
		};

		setBeforeDesc(inputDesc);
		await calculoBaixaParcial(formRefTotais.current?.getData());
	};

	// CALCULA QUANDO SAI DO CAMPO MULTA
	async function onBlurMulta() {
		const inputBaixa = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_baixa'));
		// const inputTotal = formatPriceNumber(formRefTotais.current?.getFieldValue('total'));
		const inputDesc = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_desconto'));
		const inputMulta = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_multa'));
		const inputJuros = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_juros'));

		if (inputMulta === beforeMulta) {
			return;
		}

		// const percMulta = Number(((inputMulta * 100) / (totais.baixa + totais.multa + totais.juros)).toFixed(2));
		let percMulta = 0

		if (editCredDeb === 'X') {
			percMulta = Number(((inputDesc * 100) / (totais.baixa + totais.multa + totais.juros)).toFixed(2));
		}
		else if (editCredDeb === 'C') {
			percMulta = Number(((inputDesc * 100) / (totalCred.baixa + totalCred.multa + totalCred.juros)).toFixed(2));
		}
		else {
			percMulta = Number(((inputDesc * 100) / (totalDeb.baixa + totalDeb.multa + totalDeb.juros)).toFixed(2));
		}

		if (percMulta <= params.multa_perc_maximo) {
			// const newTotal = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			const newTotal = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

			// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

			setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

			// setDisabledTabPagamento(true);
		} else {
			if (params.multa_liberacao === 'S') {
				// const newTotal = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newTotal = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

				// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));
				
				setTotais({ ...totais, total_atual: newTotal, receber: newReceber });


				// setDisabledTabPagamento(true);
			} else {
				// const newTotal = Number((totais.baixa + totais.multa + inputJuros - inputDesc).toFixed(2));
				const newTotal = Number((inputBaixa + totais.multa + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

				// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

				formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(totais.multa));
				setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

				// setDisabledTabPagamento(true);
			};
		};

		setBeforeMulta(inputMulta);
		await calculoBaixaParcial(formRefTotais.current?.getData());
	};

	// CALCULA QUANDO SAI DO CAMPO JUROS
	async function onBlurJuros() {
		const inputBaixa = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_baixa'));
		// const inputTotal = formatPriceNumber(formRefTotais.current?.getFieldValue('total'));
		const inputDesc = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_desconto'));
		const inputMulta = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_multa'));
		const inputJuros = formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_juros'));

		if (inputJuros === beforeJuros) {
			return;
		}

		// const percJuros = Number(((inputJuros * 100) / (totais.baixa + totais.multa + totais.juros)).toFixed(2));
		let percJuros = 0

		if (editCredDeb === 'X') {
			percJuros = Number(((inputDesc * 100) / (totais.baixa + totais.multa + totais.juros)).toFixed(2));
		}
		else if (editCredDeb === 'C') {
			percJuros = Number(((inputDesc * 100) / (totalCred.baixa + totalCred.multa + totalCred.juros)).toFixed(2));
		}
		else {
			percJuros = Number(((inputDesc * 100) / (totalDeb.baixa + totalDeb.multa + totalDeb.juros)).toFixed(2));
		}

		if (percJuros <= params.juros_perc_maximo) {
			// const newTotal = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			const newTotal = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

			// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
			formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

			setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

			// setDisabledTabPagamento(true);
		} else {
			if (params.juros_liberacao === 'S') {
				// const newTotal = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newTotal = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));
				
				// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

				setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

				// setDisabledTabPagamento(true);
			} else {
				// const newTotal = Number((totais.baixa + inputMulta + totais.juros - inputDesc).toFixed(2));
				const newTotal = Number((inputBaixa + inputMulta + totais.juros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('total', formatPrice(newTotal));

				// const newReceber = Number((totais.baixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				const newReceber = Number((inputBaixa + inputMulta + inputJuros - inputDesc).toFixed(2));
				formRefTotais.current?.setFieldValue('vlr_receber', formatPrice(newReceber));

				formRefTotais.current?.setFieldValue('vlr_multa', formatPrice(totais.juros));
				setTotais({ ...totais, total_atual: newTotal, receber: newReceber });

				// setDisabledTabPagamento(true);
			};
		};

		setBeforeJuros(inputJuros);
		await calculoBaixaParcial(formRefTotais.current?.getData());
	};

	// CALCULA A PORCENTUAL DE JUROS, MULT E DESCONTO, USADA NA FUNÇÃO calculoBaixaParcial
	async function calculaPercJurosMultaDesconto(soma: number, input: number, valor: number, valorBaixa: number): Promise<number> {
		if (soma !== input) {
			if (soma === 0) {
				const vlr_baixa = editCredDeb === 'X'
					? totais.baixa
					: formatPriceNumber(formRefTotais.current?.getFieldValue('vlr_baixa'));
				// const perc = Number(((input * 100) / totais.baixa).toFixed(6));
				
				const perc = Number(((input * 100) / vlr_baixa).toFixed(6));

				const valor_perc = Number(((valorBaixa * perc) / 100).toFixed(2));

				return valor_perc;
			}

			const percAlterado = Number(((input * 100) / soma).toFixed(6));

			const valor_perc = Number(((valor * percAlterado) / 100).toFixed(2));

			return valor_perc;
		} else {
			return valor;
		}
	};
	
	async function calculoBaixaParcial(form: any) {
		await payBaixasPermuta();
		const auxTitulosParaBaixa = titulosUpdate;

		let baixado = 0;
		// let soma_juros = 0, soma_multa = 0, soma_desc = 0;
		// let soma_cred = 0, soma_deb = 0;

		const inputJuros = formatPriceNumber(form.vlr_juros);
		const inputMulta = formatPriceNumber(form.vlr_multa);
		const inputDesconto = formatPriceNumber(form.vlr_desconto);
		const inputReceber = formatPriceNumber(form.vlr_receber);
		const inputTotal = formatPriceNumber(form.total);

		const auxParcelass = editCredDeb === 'X' 
			? auxParcelas 
			: editCredDeb === 'C' ? parcelasCred : parcelasDeb;

		
		for (let i = 0; i < auxTitulosParaBaixa.length; i++ ) {
			const tituloCurrent = auxTitulosParaBaixa[i];

			let soma_juros = 0, soma_multa = 0, soma_desc = 0;
			let soma_cred = 0, soma_deb = 0;

			// FOR PARA SOMA DO JUROS, MULTA, DESCONTO, TOTAIS CRED, DEB, DAS PARCELAS
			for (let x = 0; x < titulosUpdate.length; x++) {
				const auxTituloCurrent = titulosUpdate[x];

				for (let j = 0; j < auxParcelass.length; j++) {
					const parcelaCurrent = auxParcelass[j];
					
					const indexBaixa = auxTituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

					if (indexBaixa !== -1) {
						const auxBaixa = auxTituloCurrent.baixas[indexBaixa];

						soma_juros += auxBaixa.juros; // parcelaCurrent.juros;
						soma_multa += auxBaixa.multa; // parcelaCurrent.multa;
						soma_desc += auxBaixa.desconto; // parcelaCurrent.desconto;
						soma_cred += auxBaixa.vlr_cred; // parcelaCurrent.saldo_cred;
						soma_deb += auxBaixa.vlr_deb; // parcelaCurrent.saldo_deb;
					}
				};
			};

			if (soma_juros !== inputJuros || soma_multa !== inputMulta || soma_desc !== inputDesconto || inputReceber !== inputTotal) {
				baixado = inputReceber;

				for (let j = 0; j < tituloCurrent.baixas.length; j++ ) {
					const baixaCurrent = tituloCurrent.baixas[j];
					
					const indexParcela = auxParcelass.findIndex(parcela => parcela.id === baixaCurrent.id_parcela);

					if (indexParcela !== -1 && !baixaCurrent.ativa) {
						// ACHA O VALOR DA PERMUTA NO LANCAMENTO PARA FAZER A PORCENTAGEM COM O INPUT RECEBER
						const indexPermuta = lancamentoJson.lancamentos.findIndex((lancamento: any) => lancamento.pay.id_pay === 20 && lancamento.pay.name_pay === 'Permuta');
						
						/* const valorPermuta = indexPermuta === -1 ? 0
							: lancamentoJson.lancamentos[indexPermuta].vlr_cred > 0
								? lancamentoJson.lancamentos[indexPermuta].vlr_cred
								: lancamentoJson.lancamentos[indexPermuta].vlr_deb; */
						//
						// VALOR DA BAIXA, INDEPENDETE SE É CRÉDITO OU DÉBITO
						const auxValor = baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_cred : baixaCurrent.vlr_deb;
						//

						const auxSomaDesc = soma_desc < inputDesconto ? 0 : soma_desc;
						const auxSomaJuros = soma_juros < inputJuros ? 0 : soma_juros;
						const auxSomaMulta = soma_multa < inputMulta ? 0 : soma_multa;

						// CALCULA O PERCENTUAL DE DESCONTO, MULTA E JUROS SOBRE O INPUT SE OUVER ALTERAÇÃO
						let valor_perc_desc = await calculaPercJurosMultaDesconto(auxSomaDesc, inputDesconto, baixaCurrent.desconto, auxValor);
						let valor_perc_juros = await calculaPercJurosMultaDesconto(auxSomaJuros, inputJuros, baixaCurrent.juros, auxValor);
						let valor_perc_multa = await calculaPercJurosMultaDesconto(auxSomaMulta, inputMulta, baixaCurrent.multa, auxValor);
						//

						// CALCULO DE VALOR DA BAIXA + MULTA + JUROS - DESCONTO COM PERCENTUAL CORRENTE
						const calculoValor = Number((auxValor + valor_perc_juros + valor_perc_multa - valor_perc_desc).toFixed(2));
						//

						// 
						if (baixado >= calculoValor) {
							baixaCurrent.desconto = valor_perc_desc;
							baixaCurrent.multa = valor_perc_multa;
							baixaCurrent.juros = valor_perc_juros;

							baixaCurrent.vlr_pago_cred = baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_cred + valor_perc_juros + valor_perc_multa - valor_perc_desc : 0;
							baixaCurrent.vlr_pago_deb = baixaCurrent.vlr_deb > 0 ? baixaCurrent.vlr_deb + valor_perc_juros + valor_perc_multa - valor_perc_desc : 0;

							baixaCurrent.amortizado = baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_cred : baixaCurrent.vlr_deb;

							const aux = baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_pago_cred : baixaCurrent.vlr_pago_deb;

							baixado -= aux;
						}
						else {
							if (baixado <= 0) {
								baixaCurrent.vlr_pago_cred = 0;
								baixaCurrent.vlr_pago_deb = 0;
								return;
							};
							const receber_perc = Number(((baixado * 100) / auxValor).toFixed(6));

							valor_perc_desc = Number(((valor_perc_desc * receber_perc) / 100).toFixed(2));
							valor_perc_juros = Number(((valor_perc_juros * receber_perc) / 100).toFixed(2));
							valor_perc_multa = Number(((valor_perc_multa * receber_perc) / 100).toFixed(2));

							let pago = Number((auxValor + valor_perc_juros + valor_perc_multa - valor_perc_desc).toFixed(2));
							pago = pago - baixado;

							const amortizado = Number((auxValor - pago).toFixed(2));

							pago = Number((amortizado + valor_perc_juros + valor_perc_multa - valor_perc_desc).toFixed(2));

							baixaCurrent.desconto = valor_perc_desc;
							baixaCurrent.juros = valor_perc_juros;
							baixaCurrent.multa = valor_perc_multa;

							baixaCurrent.amortizado = pago - valor_perc_juros - valor_perc_multa + valor_perc_desc;

							baixaCurrent.vlr_pago_cred = baixaCurrent.vlr_cred > 0 ? pago : 0;
							baixaCurrent.vlr_pago_deb = baixaCurrent.vlr_deb > 0 ? pago : 0;

							baixado = Number((baixado - pago).toFixed(2));
						};

						titulosUpdate.forEach((tituloCurrent) => {
							const indexBaixa = tituloCurrent.baixas.findIndex(baixa => baixa.id === baixaCurrent.id);

							if (indexBaixa !== -1) {
								tituloCurrent.baixas[indexBaixa] = baixaCurrent;
								return;
							}
						});

						const auxTitulosUpdate = titulosUpdate;

						setTitulosUpdate([...auxTitulosUpdate]);
					}

					tituloCurrent.baixas[j] = baixaCurrent;
				}
			}
			auxTitulosParaBaixa[i] = tituloCurrent;
		}
		setTitulosUpdate([... auxTitulosParaBaixa]);

		// await payBaixasPermuta();
	};

	// SOMA AS PARCELAS DE CREDITO E DEBITO SEPARADAS E FAZ A DIFERENCA ENTRE ELAS
	async function handleDiferencaCredDeb() {
		let somaCred = 0, somaDeb = 0, somaTotal = 0;
		let somaDescontoCred = 0, somaDescontoDeb = 0;
		let somaJurosCred = 0, somaJurosDeb = 0;
		let somaMultaCred = 0, somaMultaDeb = 0;

		for (let i = 0; i < titulosUpdate.length; i++) {
			const tituloCurrent = titulosUpdate[i];

			for (let j = 0; j < tituloCurrent.baixas.length; j++) {
				const baixaCurrent = tituloCurrent.baixas[j];

				const indexParcela = tituloCurrent.parcelas.findIndex(parcela => !baixaCurrent.ativa && parcela.id === baixaCurrent.id_parcela);

				if (indexParcela !== -1) {
					somaTotal += baixaCurrent.vlr_cred > 0 ? baixaCurrent.vlr_cred : baixaCurrent.vlr_deb;

					if (baixaCurrent.vlr_cred > 0) {
						somaCred += baixaCurrent.vlr_cred + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
						somaDescontoCred += baixaCurrent.desconto;
						somaJurosCred += baixaCurrent.juros;
						somaMultaCred += baixaCurrent.multa;
					} else {
						somaDeb += baixaCurrent.vlr_deb + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
						somaDescontoDeb += baixaCurrent.desconto;
						somaJurosDeb += baixaCurrent.juros;
						somaMultaDeb += baixaCurrent.multa;
					}
				}
			};
		};

		return somaCred > somaDeb
			? {
				somaDesconto: Math.abs(Number((somaDescontoCred - somaDescontoDeb).toFixed(2))),
				somaJuros: Math.abs(Number((somaJurosCred - somaJurosDeb).toFixed(2))),
				somaMulta: Math.abs(Number((somaMultaCred - somaMultaDeb).toFixed(2))),
				somaReceber: Math.abs(Number((somaCred - somaDeb).toFixed(2))),
				somaTotal
			}
			: {
				somaDesconto: Math.abs(Number((somaDescontoDeb - somaDescontoCred).toFixed(2))),
				somaJuros: Math.abs(Number((somaJurosDeb - somaJurosCred).toFixed(2))),
				somaMulta: Math.abs(Number((somaMultaDeb - somaMultaCred).toFixed(2))),
				somaReceber: Math.abs(Number((somaDeb - somaCred).toFixed(2))),
				somaTotal
			};
	};

	// SUBMETE A TAB DE TOTAL E PASSA PRA PROXIMA TAB
	async function handleSubmitTotal(form: any) {
		const dif = await handleDiferencaCredDeb();

		const auxBaixa = {
			data: dataBaixa,
			qtd_parcelas: Number(form.qtd_parcelas),
			vlr_baixa: editCredDeb !== 'X' ? dif?.somaTotal : formatPriceNumber(form.vlr_baixa),
			vlr_desconto: editCredDeb !== 'X' ? dif?.somaDesconto : formatPriceNumber(form.vlr_desconto),
			vlr_multa: editCredDeb !== 'X' ? dif?.somaMulta : formatPriceNumber(form.vlr_multa),
			vlr_juros: editCredDeb !== 'X' ? dif?.somaJuros : formatPriceNumber(form.vlr_juros),
			total: editCredDeb !== 'X' ? dif?.somaReceber : formatPriceNumber(form.total),
			vlr_receber: editCredDeb !== 'X' ? dif?.somaReceber : formatPriceNumber(form.vlr_receber)
		};

		setFalta(editCredDeb !== 'X' ? dif?.somaReceber : formatPriceNumber(form.vlr_receber));
		// setFalta(formatPriceNumber(form.vlr_receber));
		setTroco(0);
		setPagamentos([]);
		setTrocos([]);
		setBaixa({ ...auxBaixa });

		const auxLancamentoJson = lancamentoJson;
		auxLancamentoJson.vlr_doc = auxBaixa.total;
		auxLancamentoJson.documentos = [];

		let somaCred = 0, somaDeb = 0;

		// ADICIONAR OS DOCUMENTOS JSON DE LANÇAMENTO
		titulosUpdate.forEach((tituloCurrent) => {
			tituloCurrent.parcelas.forEach((parcelaCurrent) => {
				auxLancamentoJson.documentos.push({
					id: tituloCurrent.id,
					type_id: tituloCurrent.operacao.id,
					type_nome: tituloCurrent.operacao.nome,
					id_parcela: parcelaCurrent.id,
					parcela: parcelaCurrent.parcela
				});

				const indexBaixa = tituloCurrent.baixas.findIndex(baixa => !baixa.ativa && baixa.id_parcela === parcelaCurrent.id);

				if (indexBaixa !== -1) {
					const baixaCurrent = tituloCurrent.baixas[indexBaixa];

					if (baixaCurrent.vlr_cred > 0) {
						somaCred += baixaCurrent.vlr_cred + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
					} else {
						somaDeb += baixaCurrent.vlr_deb + baixaCurrent.juros + baixaCurrent.multa - baixaCurrent.desconto;
					}
				}
			});
		});

		setLancamentoJson({ ...lancamentoJson, lancamentos: [] });

		// ADICIONA SE OUVER PERMUTA NOS LANÇAMENTOS
		const permuta = operacao === 'C' && 
			totalDeb.total > 0
				? true 
					: operacao === 'D' && 
						totalCred.total > 0 ? true : false;

		if (permuta) {
			if (auxLancamentoJson.lancamentos.length > 0 ) {
				auxLancamentoJson.lancamentos = [];
			}

			const newLancamentoCred = {
				id: uuid(),
				ativa: true,
				vlr_cred: operacao === 'C' ? somaDeb : somaCred, // totalDeb.pago : totalCred.pago,
				vlr_deb: 0,
				vlr_pago_cred: operacao === 'C' ? somaDeb : somaCred, // totalDeb.pago : totalCred.pago,
				vlr_pago_deb: 0,
				caixa: {
					id: caixaRateio.caixa_id,
					nome: caixaRateio.caixa_nome,
					user_id: Number(user.id),
					user_nome: user.nome,
					compensado: true
				},
				data: baixa.data,
				pay: payRateio
			};

			const newLancamentoDeb = {
				id: uuid(),
				ativa: true,
				vlr_cred: 0,
				vlr_deb: operacao === 'C' ? somaDeb : somaCred, // totalDeb.pago : totalCred.pago,
				vlr_pago_cred: 0,
				vlr_pago_deb: operacao === 'C' ? somaDeb : somaCred, // totalDeb.pago : totalCred.pago,
				caixa: {
					id: caixaRateio.caixa_id,
					nome: caixaRateio.caixa_nome,
					user_id: Number(user.id),
					user_nome: user.nome,
					compensado: true
				},
				data: baixa.data,
				pay: payRateio
			};

			if (operacao === 'C') {
				auxLancamentoJson.lancamentos.push(newLancamentoDeb);
				auxLancamentoJson.lancamentos.push(newLancamentoCred);
			} else {
				auxLancamentoJson.lancamentos.push(newLancamentoCred);
				auxLancamentoJson.lancamentos.push(newLancamentoDeb);
			}

			setLancamentoJson({ ...auxLancamentoJson });
		};
		//

		await editClienteLancamento();
		await calculoBaixaParcial(form);
		
		setDisabledTabPagamento(false);
		setTabIndex(2);
	};

	async function removePagBaixa(id: string) {
		const indexPag = pagamentos.findIndex(pag => pag.id === id);
		const auxPagamentos = pagamentos;

		if (troco > 0) {
			const restoTroco = Number((troco - formatPriceNumber(auxPagamentos[indexPag].valor)).toFixed(2));

			if (restoTroco < 0) {
				setTroco(0);
				setFalta(Math.abs(restoTroco));
			} else {
				setTroco(restoTroco);
			};
		} else {
			const filterPag = pagamentos.filter(pag => pag.id !== id);
			let soma = 0;

			filterPag.forEach((filterPagCurrent) => {
				soma = Number((soma + formatPriceNumber(filterPagCurrent.valor)).toFixed(2));
			});

			soma = Number((baixa.vlr_receber - soma).toFixed(2));

			if (soma > 0) {
				setFalta(soma);
			} else {
				setTroco(soma);
			};

			setTrocos([]);

			// const newFalta = Number((falta + formatPriceNumber(auxPagamentos[indexPag].valor)).toFixed(2));
			// setFalta(newFalta);
		};

		const auxLancamentoJson = lancamentoJson;
		const indexLancamento = lancamentoJson.lancamentos.findIndex((item: any) => item.id === id);
		auxLancamentoJson.lancamentos.splice(indexLancamento, 1);
		setLancamentoJson({...auxLancamentoJson});

		auxPagamentos.splice(indexPag, 1);
		setPagamentos([...auxPagamentos]);
	};

	async function removeTrocoBaixa(id: string) {
		const indexTroco = trocos.findIndex(trocoo => trocoo.id === id);
		const auxTrocos = trocos;

		const somaTroco = Number((troco + formatPriceNumber(auxTrocos[indexTroco].valor)).toFixed(2));

		const auxLancamentoJson = lancamentoJson;
		const indexLancamento = lancamentoJson.lancamentos.findIndex((item: any) => item.id === id);
		auxLancamentoJson.lancamentos.splice(indexLancamento, 1);
		setLancamentoJson({ ...auxLancamentoJson });

		auxTrocos.splice(indexTroco, 1);
		setTrocos([...auxTrocos]);
		setTroco(somaTroco);
	};

	function handleCancel(is_toast: boolean) {
		if (!is_toast) {
			const r = window.confirm(
				'Você não salvou suas alterações!\nDeseja sair sem salvar?',
			);

			if (r) {
				formRefTotais.current?.reset();
				handleForm();
				// titulos = [];
				setTitulosUpdate([]);
				setTitulosParaBaixa([]);
				setVisible(false);
				onClose(false);
			} else { return; };
		};

		toast({
			title: 'Baixas.',
			description: `Operação de baixas cancelada!`,
			status: 'warning',
			duration: 2000,
			position: 'top',
			isClosable: true,
			containerStyle: {
				marginTop: '5'
			}
		});

		formRefTotais.current?.reset();

		handleForm();
		// titulosParaBaixa = [];
		setTitulosUpdate([]);
		setTitulosParaBaixa([]);
		setVisible(false);
		onClose(false);
	};

	async function updateParcelas() {
		const auxTitulosUpdate = titulosUpdate;
		for (let i = 0; i < auxTitulosUpdate.length; i++) {
			const tituloCurrent = auxTitulosUpdate[i];

			for (let j = 0; j < tituloCurrent.baixas.length; j++) {
				const baixaCurrent = tituloCurrent.baixas[j];

				const indexParcela = tituloCurrent.parcelas.findIndex((parcela => parcela.id === baixaCurrent.id_parcela));

				if (indexParcela !== -1 && !baixaCurrent.ativa) {
					const parcelaCurrent = tituloCurrent.parcelas[indexParcela];

					parcelaCurrent.data_baixa = baixaCurrent.data;
					parcelaCurrent.amortizado += baixaCurrent.amortizado;
					parcelaCurrent.desconto = baixaCurrent.desconto;
					parcelaCurrent.juros = baixaCurrent.juros;
					parcelaCurrent.multa = baixaCurrent.multa;

					parcelaCurrent.pago = baixaCurrent.vlr_pago_cred > 0 ? baixaCurrent.vlr_pago_cred : baixaCurrent.vlr_pago_deb;

					parcelaCurrent.saldo_cred -= baixaCurrent.vlr_cred > 0 ? baixaCurrent.amortizado : 0;
					parcelaCurrent.saldo_deb -= baixaCurrent.vlr_deb > 0 ? baixaCurrent.amortizado : 0;

					parcelaCurrent.baixado = parcelaCurrent.saldo_cred === 0 && parcelaCurrent.saldo_deb === 0 ? true : false;

					titulosUpdate[i].parcelas[indexParcela] = parcelaCurrent;
					titulosUpdate[i].baixas[j].ativa = true;
				}
			}
		}
	};

	async function handleSubmitBaixa() {
		try {
			const auxPays: PayDTO[] = [];
			let pagPix: any;
			// for PARA REMOVER OS CAMPOS value e label DOS PAGAMENTOS
			pagamentos.forEach((pagamentoCurrent) => {
				const auxPay = pagamentoCurrent.pay;
				delete auxPay.value;
				delete auxPay.label;
				auxPays.push(auxPay);

				pagamentoCurrent.pay.band_pay === 'PIX' && (pagPix = pagamentoCurrent);
			});
			//
			// PARA ADICIONAR OS pays DE PERMUTA NAS BAIXAS
			const permuta = operacao === 'C' && totalDeb.total > 0 ? true :
				operacao === 'D' && totalCred.total > 0 ? true : false;

			if (permuta) {
				lancamentoJson.lancamentos.forEach((lancamentoCurrent: any) => {
					if (lancamentoCurrent.pay.id_pay === 20) {
						auxPays.push(lancamentoCurrent.pay);
					}
				});
			};
			//
			// for PARA REMOVER OS CAMPOS value e label DOS PAYS
			trocos.forEach((trocoCurrent) => {
				const auxPay = trocoCurrent.pay;
				delete auxPay.value;
				delete auxPay.label;
				auxPay.name_pay = `${auxPay.name_pay} - Troco`;
				auxPays.push(auxPay);
			});
			//
			// for PARA INCLUIR O ARRAY DE PAY NAS BAIXAS DOS TÍTULOS
			titulosUpdate.forEach((tituloCurrent) => {
				tituloCurrent.baixas.forEach((baixaCurrent) => {
					baixaCurrent.pay = auxPays;
				});
			});
			//
			lancamentoJson.data = baixa.data;

			await updateParcelas();

			// await api.post('/portal/financeiro/store/baixa', { lancamentoJson, titulosUpdate });

			console.log('lancamentoJson ==> ', lancamentoJson);

			if (pagPix) {
				console.log('pagPix ==> ', pagPix);
				const docs: any[] = [];

				lancamentoJson.documentos.forEach((documento: any) => {
					docs.push({
						id: documento.id,
						id_parcela: documento.id_parcela,
					});
				});

				setPixParams({
					user_id: lancamentoJson.cliente.id,
					user_nome: lancamentoJson.cliente.nome,
					user_doc: lancamentoJson.cliente.doc,
					valor: formatPriceNumber(pagPix.valor).toString(),
					chave_pix: pagPix.pay.chave_pay,
					id_baixa: lancamentoJson.id,
					documentos: docs
				});
			};

			setModalPagPixVisible(true);
			
			/* toast({
				title: 'Baixa.',
				description: 'Baixa feita com sucesso!',
				status: 'success',
				duration: 5000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				},
			}); */

		} catch (error) {
			toast({
				title: 'Erro',
				description: `Tente novamente mais tarde - ${error}`,
				status: 'error',
				duration: 5000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				},
			});

		} finally {
			/* titulos = [];
			setTitulosParaBaixa([]);
			setLancamentoJson({});
			await handleForm();
			setVisible(false);
			onClose(); */
		}
	};

	return (
		<Container id="ModalTituloBaixa">
			<Content className={`${visible ? 'active' : ''}`}>
				<Header>
					<Tag
						size='lg'
						colorScheme="transparent"
						borderRadius='full'
						fontSize={20}
						fontWeight={600}
					>
						{/* <TagLabel>TESTE</TagLabel> */}
					</Tag>
					
					<Tag
						size='lg'
						colorScheme={operacao === 'C' ? "blue" : operacao === 'D' ? "red" : "gray"}
						borderRadius='full'
						fontSize={20}
						fontWeight={600}
					>
						<TagLabel>Baixa de {operacao === 'C' ? 'Recebimento' : operacao === 'D' ? 'Pagamento' : 'Parcelas'}</TagLabel>
					</Tag>
				</Header>
 
				<TabsView>
					<Tabs className="tabs" index={tabIndex}>
						<TabList className="tab-list" mt={-2} overflowX="auto" scrollBehavior="smooth">
							<Tab className="tab" onClick={() => setTabIndex(0)}>DATA BAIXA</Tab>

							<Tab className="tab" onClick={() => setTabIndex(1)} isDisabled={disabledTabTotal}>
								TOTAL
							</Tab>

							<Tab className="tab" onClick={() => setTabIndex(2)} isDisabled={disabledTabPagamento}>
								PAGAMENTO
							</Tab>
						</TabList>

						<TabPanels className="tab-panels">
							<TabDataBaixa className="tab-panel" overflowY="auto" scrollBehavior="smooth" mt={1.5}>
								<TituloItem>
									<FormView ref={formRef} onSubmit={() => { }}>
										{/* DATA EMISSÃO */}
										<div className="input" style={{ width: '50%' }}>
											<p>Data da baixa <span>(obrigatório)</span></p>
											<InputDate
												name="data_baixa"
												placeholder="Data da baixa"
												value={format(add(new Date(dataBaixa), { days: 1 }), "Y'-'MM'-'dd", { locale: ptBR })}
												containerStyle={{ padding: '6px 10px' }}
												onChange={(e) => {
													setDataBaixa(e.target.value);
													setDisabledTabPagamento(true);
													setDisabledTabTotal(true);
												}}
											/>
										</div>
									</FormView>
								</TituloItem>

								{titulos.map(titulo => {
									return (
										<TituloItem key={titulo.id}>
											<Flex align="center" py={1}>
												<Text fontSize={18} fontWeight={500}>
													{titulo.cliente.nome} &nbsp;- &nbsp;
													{titulo.aux_total_parcs?.total_formatted}
												</Text>

												{titulo.parcelas.length > 1 && (
													<Icon
														as={FiTrash2}
														color="red.800"
														fontSize={20}
														cursor="pointer"
														ml={2}
														onClick={() => handleDeleteParcelaTitulo('', titulo.id, true)}
													/>
												)}
											</Flex>

											<Accordion allowMultiple>
												{titulo.parcelas.map(parcela => {
													return (
														<Flex key={parcela.id} w="100%" align="center" mb={2}>
															<Flex bg={parcela.vlr_cred > 0 ? "blue.100" : "red.200"} px={2} py={2.5} borderRadius={4} mr={1}>
																<Icon
																	as={FiTrash2}
																	color="red.800"
																	fontSize={20}
																	cursor="pointer"
																	onClick={() => handleDeleteParcelaTitulo(parcela.id, titulo.id, false)}
																/>
															</Flex>

															<AccordionItem
																key={parcela.id}
																border={0}
																bg={parcela.vlr_cred > 0 ? "blue.100" : "red.200"}
																borderRadius={4}
																w="100%"
															>
																<AccordionButton 
																	m="0px !important"
																	p="8px 8px 8px 0px !important"
																	_hover={{ background: "transparent" }}
																>
																	<Box as="h2" flex={1} textAlign="left">
																		<span>{parcela.parcela}</span>
																		&nbsp;
																		Venc: <span>
																			{format(add(new Date(parcela.vencimento), { days: 1 }),
																				"dd'/'MM'/'Y", { locale: ptBR })}
																		</span>
																		&nbsp;-&nbsp;Vlr:&nbsp;
																		<span>{formatPrice(parcela.vlr_cred + parcela.vlr_deb)}</span>
																	</Box>
																	<AccordionIcon color="blue.500" />
																</AccordionButton>

																<AccordionPanel px={2} pt={-2} pb={4}>
																	<Flex>
																		<h2>Operação: <span>{parcela.vlr_cred > 0 ? 'Crédito' : 'Débito'}</span></h2>
																		{/* <h2>Valor: <span>{formatPrice(parcela.vlr_cred + parcela.vlr_deb)}</span></h2> */}
																	</Flex>

																	<h2>Desconto: <span>{formatPrice(parcela.desconto)}</span></h2>
																	<h2>Pago: <span>{formatPrice(parcela.pago)}</span></h2>
																	<h2>Amortizado: <span>{formatPrice(parcela.amortizado)}</span></h2>

																	<Flex>
																		<h2>Juros: <span>{formatPrice(parcela.juros)}</span></h2>
																		<h2>Multa: <span>{formatPrice(parcela.multa)}</span></h2>
																	</Flex>

																	{parcela.taxa_card || parcela.taxa_antecip && (
																		<Flex>
																			{parcela.taxa_card && (
																				<h2>Taxa Cartão: <span>{formatPrice(parcela.taxa_card)}</span></h2>
																			)}

																			{parcela.taxa_antecip && (
																				<h2>Taxa Antecipação: <span>{formatPrice(parcela.taxa_antecip)}</span></h2>
																			)}
																		</Flex>
																	)}

																	<h2>Outra Despesa: <span>{formatPrice(parcela.outra_desp)}</span></h2>

																	<Flex>
																		<h2>Saldo: <span>{formatPrice(parcela.saldo_cred + parcela.saldo_deb)}</span></h2>
																	</Flex>

																	{parcela.data_baixa && (
																		<h2>Data Baixa:
																			<span>
																				{format(add(new Date(parcela.data_baixa), { days: 1 }),
																					"dd'/'MM'/'Y", { locale: ptBR })}
																			</span>
																		</h2>
																	)}

																	{parcela.boleto && (
																		<Flex flexDir="column">
																			<Text color="gray.700" fontWeight={500}>Boleto:</Text>

																			<Flex
																				flexDir="column"
																				borderWidth={2}
																				borderColor="gray.100"
																				borderRadius={8}
																				ml={2}
																				py={1}
																				mb={1}
																			>
																				<h2>Nosso Nro: <span>{parcela.boleto.nosso_nro}</span></h2>
																				<h2>Linha Dig:&nbsp;
																					<Text
																						as="button"
																						onClick={() => handleCopy(parcela.boleto.linha_dig)}
																					>
																						<span style={{ color: '#1a83ff' }}>{parcela.boleto.linha_dig}</span>
																					</Text>
																				</h2>
																				<h2>Status: <span>{parcela.boleto.registro}</span></h2>
																				{parcela.boleto.venc && (
																					<h2>Vencimento:
																						<span>
																							{format(add(new Date(parcela.boleto.venc), { days: 1 }),
																								" dd'/'MM'/'Y", { locale: ptBR })}
																						</span>
																					</h2>
																				)}
																				<h2>Valor: <span>{formatPrice(parcela.boleto.vlr)}</span></h2>
																				<Flex>
																					<h2>Multa: <span>{formatPrice(parcela.boleto.multa)}</span></h2>
																					<h2>Mora: <span>{formatPrice(parcela.boleto.mora)}</span></h2>
																				</Flex>
																			</Flex>
																		</Flex>
																	)}
																</AccordionPanel>
															</AccordionItem>
														</Flex>
													)
												})}
											</Accordion>
										</TituloItem>
									)
								})}

								<Buttons>
									<Flex flexDir="column" pl={4} py={0}>
										<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
										<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
									</Flex>

									<Flex className="buttons">
										<button
											type="button"
											className="button-cancel"
											onClick={() => {
												// handleCancel(false);
												setTextAlert({
													header: 'Cancelar Baixa!',
													body: 'Você não salvou suas alterações!\n\nDeseja sair sem salvar?',
													is_toast: true,
												});
												setOpenAlert(true);
											}}
										>
											Cancelar
										</button>

										<button
											type="submit"
											className="button-save"
											onClick={() => {
												// setTabIndex(1);
												handleSubmitTabDataBaixa();
												// handleTotaisJurosMultaDesconto();
											}}
										>
											&nbsp;&nbsp;&nbsp;Próximo&nbsp;&nbsp;&nbsp;
										</button>
									</Flex>
								</Buttons>
							</TabDataBaixa>

							<TabTotais className="tab-panel" overflowY="auto" scrollBehavior="smooth" mt={1.5}>
								<Flex
									w="100%"
									px={2} pb={2}
									borderWidth={3}
									borderColor={editCredDeb === 'N' || editCredDeb === 'X' ? 'gray.200'
										: editCredDeb === 'C' ? 'blue.500'
										: 'red.500'
									}
									borderRadius={8}
								>
									<FormView ref={formRefTotais} onSubmit={() => {}}>
										{/* DATA BAIXA / QTD PARCELAS */}
										<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
											{/* DATA BAIXA */}
											< div className="input">
												<p>Data baixa <span>(obrigatório)</span></p>
												<Input
													name="dataBaixa"
													type="text"
													placeholder="Data Baixa"
													value={format(add(new Date(dataBaixa), { days: 1 }), "dd'/'MM'/'Y", { locale: ptBR })}
													onChange={(e) => setDataBaixa(e.target.value)}
													disabled
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>

											{/* QTD PARCELAS */}
											<div className="input">
												<p>Qtd Parcelas <span>(obrigatório)</span></p>
												<Input
													name="qtd_parcelas"
													type="text"
													placeholder="Qtd parcelas"
													disabled
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>
										</Stack>

										{/* VLR BAIXA / VLR DESCONTO */}
										<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
											{/* VLR BAIXA */}
											< div className="input">
												<p>Valor da Baixa <span>(obrigatório)</span></p>
												<Input
													name="vlr_baixa"
													type="text"
													placeholder="Valor da Baixa"
													onChange={() => formatInputMoeda('vlr_baixa', formRefTotais)}
													disabled
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>

											{/* VLR DESCONTO */}
											<div className="input">
												<p>Valor Desconto <span>(obrigatório)</span></p>
												<Input
													name="vlr_desconto"
													type="text"
													placeholder="Valor do desconto"
													onChange={() => {
														formatInputMoeda('vlr_desconto', formRefTotais);
														setDisabledTabPagamento(true);
													}}
													handleOnBlur={onBlurDesconto}
													disabled={params && params.desc_alterar === 'N'}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>
										</Stack>

										{/* VLR MULTA / VLR JUROS */}
										<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
											{/* VLR MULTA */}
											< div className="input">
												<p>Valor Multa <span>(obrigatório)</span></p>
												<Input
													name="vlr_multa"
													type="text"
													placeholder="Valor da multa"
													onChange={() => {
														formatInputMoeda('vlr_multa', formRefTotais);
														setDisabledTabPagamento(true);
													}}
													handleOnBlur={onBlurMulta}
													disabled={params && params.multa_alterar === 'N'}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>

											{/* VLR JUROS */}
											<div className="input">
												<p>Valor Juros <span>(obrigatório)</span></p>
												<Input
													name="vlr_juros"
													type="text"
													placeholder="Valor do juros"
													onChange={() => {
														formatInputMoeda('vlr_juros', formRefTotais);
														setDisabledTabPagamento(true);
													}}
													handleOnBlur={onBlurJuros}
													disabled={params && params.juros_alterar === 'N'}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>
										</Stack>

										{/* TOTAL / VLR RECEBER */}
										<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
											{/* TOTAL */}
											< div className="input">
												<p>Total <span>(obrigatório)</span></p>
												<Input
													name="total"
													type="text"
													placeholder="Valor total"
													onChange={() => {
														formatInputMoeda('total', formRefTotais);
														setDisabledTabPagamento(true);
													}}
													handleOnBlur={params && params.multa_alterar === 'N' ? onBlurTotalNotMulta : onBlurTotal}
													disabled={params && params.total_alterar === 'N'}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>

											{/* VLR RECEBER */}
											<div className="input">
												<p>Valor Receber <span>(obrigatório)</span></p>
												<Input
													name="vlr_receber"
													type="text"
													placeholder="Valor a receber"
													onChange={() => {
														formatInputMoeda('vlr_receber', formRefTotais);
														setDisabledTabPagamento(true);
													}}
													handleOnBlur={(e) => {
														const auxValue = formatPriceNumber(e.target.value);
														const auxTotal = formatPriceNumber(formRefTotais.current?.getFieldValue('total'));

														if (auxValue > auxTotal) {
															formRefTotais.current?.setFieldValue('total', e.target.value);
															params && params.multa_alterar === 'N' ? onBlurTotalNotMulta() : onBlurTotal();
														}
													}}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>
										</Stack>
									</FormView>
								</Flex>

								{editCredDeb !== 'X' && (
									<Flex w="100%" mt={-1.5}>
										<Flex
											flexDir="column"
											justify="end"
											cursor="pointer"
											px={4} py={2}
											ml={3} mt={editCredDeb === 'C' ? 1 : 3}
											borderRadius={8}
											borderTopLeftRadius={editCredDeb === 'C' ? 0 : 8}
											borderTopRightRadius={editCredDeb === 'C' ? 0 : 8}
											background={editCredDeb === 'C' ? 'blue.500' : 'gray.300'}
											color={editCredDeb === 'C' ? 'white' : 'gray.800'}

											_hover={{
												background: editCredDeb === 'C' ? 'blue.600' : 'gray.400',
												color: editCredDeb === 'C' ? 'white' : 'gray.800',
											}}
											onClick={() => {
												setEditCredDeb('C');
												somaTotaisCredDebForm('C');
											}}
										>
											<Text fontSize={16} fontWeight="bold">Crédito</Text>
										</Flex>

										<Flex
											flexDir="column"
											justify="end"
											cursor="pointer"
											px={4} py={2}
											ml={3} mt={editCredDeb === 'D' ? 1 : 3}
											borderRadius={8}
											borderTopLeftRadius={editCredDeb === 'D' ? 0 : 8}
											borderTopRightRadius={editCredDeb === 'D' ? 0 : 8}
											background={editCredDeb === 'D' ? 'red.500' : 'gray.300'}
											color={editCredDeb === 'D' ? 'white' : 'gray.800'}

											_hover={{
												background: editCredDeb === 'D' ? 'red.600' : 'gray.400',
												color: editCredDeb === 'D' ? 'white' : 'gray.800',
											}}
											onClick={() => {
												setEditCredDeb('D');
												somaTotaisCredDebForm('D');
											}}
										>
											<Text fontSize={16} fontWeight="bold">Débito</Text>
										</Flex>
									</Flex>
								)}
								

								{titulosUpdate.map(titulo => {
									return (
										<TituloItem key={titulo.id}>
											<Flex align="center" py={1}>
												<Text fontSize={16} fontWeight={500}>
													{titulo.cliente.nome} &nbsp;- &nbsp;
													{titulo.aux_total_parcs?.total_formatted}
												</Text>
											</Flex>

											<Accordion allowMultiple>
												{titulo.baixas?.map(baixa => {
													const indexParcela = titulo.parcelas.findIndex(parcela => parcela.id === baixa.id_parcela);

													// MOSTRA SOMENTE AS BAIXAS DAS PARCELAS SELECIONADAS
													return (indexParcela !== -1 && !baixa.ativa) && (
														<Flex key={baixa.id} w="100%" align="center" mb={2}>
															<AccordionItem
																border={0}
																bg={baixa.vlr_cred > 0 ? "blue.100" : "red.200"}
																borderRadius={4}
																w="100%"
															>
																<AccordionButton
																	m="0px !important"
																	p="8px 8px 8px 0px !important"
																	_hover={{ background: "transparent" }}
																>
																	<Stack
																		w="100%"
																		as="h2"
																		spacing={1}
																		direction={["column", "row"]}
																		fontSize={14}
																	>
																		<Stack spacing={1} direction="row">
																			<Text><span>{baixa.parcela}</span></Text>

																			<Text>
																				&nbsp;Venc:&nbsp;
																				<span>
																					{format(add(new Date(titulo.parcelas[indexParcela].vencimento), { days: 1 }),
																						"dd'/'MM'/'Y", { locale: ptBR })}
																				</span>
																			</Text>

																			<Text>-</Text>

																			<Text>
																				Saldo:&nbsp;
																				<span>{formatPrice(baixa.vlr_cred > 0 ? baixa.vlr_cred : baixa.vlr_deb)}</span>
																			</Text>
																		</Stack>

																		<Stack spacing={1} direction="row">
																			<Text>-</Text>
																			<Text>
																				Pago:&nbsp;
																				<span>{formatPrice(baixa.vlr_pago_cred > 0 ? baixa.vlr_pago_cred : baixa.vlr_pago_deb)}</span>
																			</Text>
																		</Stack>
																	</Stack>
																	<AccordionIcon color="blue.500" />
																</AccordionButton>

																<AccordionPanel px={2} pt={-2} pb={4} fontSize={14}>
																	<Flex>
																		<h2>Operação: <span>{baixa.vlr_cred > 0 ? 'Crédito' : 'Débito'}</span></h2>
																		<h2>Valor: <span>{formatPrice(baixa.vlr_cred > 0 ? baixa.vlr_cred : baixa.vlr_deb)}</span></h2>
																	</Flex>

																	<h2>Desconto: <span>{formatPrice(baixa.desconto)}</span></h2>
																	<Flex>
																		<h2>Juros: <span>{formatPrice(baixa.juros)}</span></h2>
																		<h2>Multa: <span>{formatPrice(baixa.multa)}</span></h2>
																	</Flex>

																	<h2>Outras Despesas: <span>{formatPrice(baixa.outra_desp)}</span></h2>

																	{baixa.taxa_card > 0 && (
																		<Flex>
																			<h2>Taxa Cartão: <span>{formatPrice(baixa.taxa_card)}</span></h2>
																		</Flex>
																	)}

																	{baixa.taxa_antecip > 0 && (
																		<Flex>
																			<h2>Taxa Antecipação: <span>{formatPrice(baixa.taxa_antecip)}</span></h2>
																		</Flex>
																	)}

																	<h2>Pago: <span>{formatPrice(baixa.vlr_pago_cred > 0 ? baixa.vlr_pago_cred : baixa.vlr_pago_deb)}</span></h2>

																	<h2>Amortizado: <span>{formatPrice(baixa.amortizado)}</span></h2>
																</AccordionPanel>
															</AccordionItem>
														</Flex>
													)
												})}

												{/* titulo.parcelas.map(parcela => {
													return (
														<Flex key={parcela.id} w="100%" align="center" mb={2}>
															<AccordionItem
																border={0}
																bg={parcela.vlr_cred > 0 ? "blue.100" : "red.200"}
																borderRadius={4}
																w="100%"
															>
																<AccordionButton 
																	m="0px !important"
																	p="8px 8px 8px 0px !important"
																	_hover={{ background: "transparent" }}
																>
																	<Stack
																		w="100%"
																		as="h2"
																		spacing={1}
																		direction={["column", "row"]}
																		fontSize={14}
																	>
																		<Stack spacing={1} direction="row">
																			<Text><span>{parcela.parcela}</span></Text>
																			
																			<Text>
																				&nbsp;Venc:&nbsp;
																				<span>
																					{format(add(new Date(parcela.vencimento), { days: 1 }),
																						"dd'/'MM'/'Y", { locale: ptBR })}
																				</span>
																			</Text>

																			<Text>-</Text>
																			
																			<Text>
																				Saldo:&nbsp;
																				<span>{formatPrice(parcela.saldo_cred + parcela.saldo_deb)}</span>
																			</Text>
																		</Stack>

																		<Stack spacing={1} direction="row">
																			<Text>-</Text>
																			<Text>
																				Pago:&nbsp;
																				<span>{formatPrice(parcela.pago)}</span>
																			</Text>
																		</Stack>
																	</Stack>
																	<AccordionIcon color="blue.500" />
																</AccordionButton>

																<AccordionPanel px={2} pt={-2} pb={4} fontSize={14}>
																	<Flex>
																		<h2>Operação: <span>{parcela.vlr_cred > 0 ? 'Crédito' : 'Débito'}</span></h2>
																		<h2>Valor: <span>{formatPrice(parcela.vlr_cred + parcela.vlr_deb)}</span></h2>
																	</Flex>

																	<h2>Desconto: <span>{formatPrice(parcela.desconto)}</span></h2>
																	<Flex>
																		<h2>Juros: <span>{formatPrice(parcela.juros)}</span></h2>
																		<h2>Multa: <span>{formatPrice(parcela.multa)}</span></h2>
																	</Flex>

																	<h2>Outras Despesas: <span>{formatPrice(parcela.outra_desp)}</span></h2>

																	{parcela.taxa_card || parcela.taxa_antecip && (
																		<Flex>
																			{parcela.taxa_card && (
																				<h2>Taxa Cartão: <span>{formatPrice(parcela.taxa_card)}</span></h2>
																			)}

																			{parcela.taxa_antecip && (
																				<h2>Taxa Antecipação: <span>{formatPrice(parcela.taxa_antecip)}</span></h2>
																			)}
																		</Flex>
																	)}

																	<h2>Amortizado: <span>{formatPrice(parcela.amortizado)}</span></h2>
																	<h2>Pago: <span>{formatPrice(parcela.pago)}</span></h2>
																	<h2>Saldo: <span>{formatPrice(parcela.saldo_cred + parcela.saldo_deb)}</span></h2>

																	{parcela.data_baixa && (
																		<h2>Data Baixa:&nbsp;
																			<span>
																				{format(add(new Date(parcela.data_baixa), { days: 1 }),
																					"dd'/'MM'/'Y", { locale: ptBR })}
																			</span>
																		</h2>
																	)}

																	{parcela.boleto && (
																		<Flex flexDir="column">
																			<Text color="gray.700" fontWeight={500}>Boleto:</Text>

																			<Flex
																				flexDir="column"
																				borderWidth={2}
																				// borderColor="gray.100"
																				borderColor="white"
																				borderRadius={8}
																				ml={2}
																				py={1}
																				mb={1}
																			>
																				<h2>Nosso Nro: <span>{parcela.boleto.nosso_nro}</span></h2>
																				<h2>Linha Dig:&nbsp;
																					<Text
																						as="button"
																						onClick={() => handleCopy(parcela.boleto.linha_dig)}
																					>
																						<span style={{ color: '#1a83ff' }}>{parcela.boleto.linha_dig}</span>
																					</Text>
																				</h2>
																				<h2>Status: <span>{parcela.boleto.registro}</span></h2>
																				{parcela.boleto.venc && (
																					<h2>Vencimento:
																						<span>
																							{format(add(new Date(parcela.boleto.venc), { days: 1 }),
																								" dd'/'MM'/'Y", { locale: ptBR })}
																						</span>
																					</h2>
																				)}
																				<h2>Valor: <span>{formatPrice(parcela.boleto.vlr)}</span></h2>
																				<Flex>
																					<h2>Multa: <span>{formatPrice(parcela.boleto.multa)}</span></h2>
																					<h2>Mora: <span>{formatPrice(parcela.boleto.mora)}</span></h2>
																				</Flex>
																			</Flex>
																		</Flex>
																	)}
																</AccordionPanel>
															</AccordionItem>
														</Flex>
													)
												}) */}
											</Accordion>
										</TituloItem>
									)
								})}

								<Buttons>
									<Flex w="100%" justify="flex-start" flexDir="column" pl={4} py={0}>
										<Text fontSize={[12, 14]} fontWeight={400}>Usuário:</Text>
										<Text pl={2} fontSize={[13, 15]} fontWeight={500}>{user.nome}</Text>
									</Flex>

									<Flex className="buttons">
										<button
											type="button"
											className="button-cancel"
											onClick={() => {
												// handleCancel(false);
												setTextAlert({
													header: 'Cancelar Baixa!',
													body: 'Você não salvou suas alterações!' + "\n" +'Deseja sair sem salvar?',
													is_toast: true,
												});
												setOpenAlert(true);
											}}
										>
											Cancelar
										</button>

										<button
											type="submit"
											className="button-save"
											onClick={() => handleSubmitTotal(formRefTotais.current?.getData())}
										>
											&nbsp;&nbsp;&nbsp;Próximo&nbsp;&nbsp;&nbsp;
										</button>
									</Flex>
								</Buttons>
							</TabTotais>

							<TabPagamento className="tab-panel" overflowY="auto" scrollBehavior="smooth" mt={1.5}>
								<Flex
									flexDir="column"
									w="100%"
									borderWidth={2}
									borderColor="gray.200"
									borderRadius={8}
									px={2}
									pb={2}
									mb={4}
								>
									{/* DATA BAIXA / QTD PARCELAS */}
									<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
										{/* DATA BAIXA */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Data baixa:</Text>&nbsp;
											<Text fontWeight={500}>{format(add(new Date(dataBaixa), { days: 1 }), "dd'/'MM'/'Y", { locale: ptBR })}</Text>
										</Flex>

										{/* QTD PARCELAS */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Qtd Parcelas:</Text> &nbsp;
											<Text fontWeight={500}>{baixa.qtd_parcelas}</Text>
										</Flex>
									</Stack>

									{/* VLR BAIXA / VLR DESCONTO */}
									<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
										{/* VLR BAIXA */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Vlr da baixa:</Text> &nbsp;
											<Text fontWeight={500}>{formatPrice(baixa.vlr_baixa)}</Text>
										</Flex>

										{/* VLR DESCONTO */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Vlr do desconto:</Text> &nbsp;
											<Text fontWeight={500}>{formatPrice(baixa.vlr_desconto)}</Text>
										</Flex>
									</Stack>

									{/* VLR MULTA / VLR JUROS */}
									<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
										{/* VLR MULTA */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Vlr da multa:</Text> &nbsp;
											<Text fontWeight={500}>{formatPrice(baixa.vlr_multa)}</Text>
										</Flex>

										{/* VLR JUROS */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Vlr do juros:</Text> &nbsp;
											<Text fontWeight={500}>{formatPrice(baixa.vlr_juros)}</Text>
										</Flex>
									</Stack>

									{/* TOTAL / VLR RECEBER */}
									<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
										{/* TOTAL */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Vlr Total:</Text> &nbsp;
											<Text fontWeight={500}>{formatPrice(baixa.total)}</Text>
										</Flex>

										{/* VLR RECEBER */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Vlr a receber:</Text> &nbsp;
											<Text fontWeight={500}>{formatPrice(baixa.vlr_receber)}</Text>
										</Flex>
									</Stack>

									{/* FALTA / TROCO */}
									<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
										{/* FALTA */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Falta:</Text> &nbsp;
											<Text fontWeight={500} color={falta > 0 ? "red.800" : "gray.700"}>
												{formatPrice(falta)}
											</Text>
										</Flex>

										{/* TROCO */}
										<Flex w="100%">
											<Text fontWeight={500} color="gray.600">Troco:</Text> &nbsp;
											<Text fontWeight={500} color={troco > 0 ? "red.800" : "gray.700"}>
												{formatPrice(troco)}
											</Text>
										</Flex>
									</Stack>
								</Flex>

								{(lancamentoJson.lancamentos 
									&& lancamentoJson.lancamentos.length > 0 
									&& lancamentoJson.lancamentos[0].pay.id_pay === 20) && 
								(
									<Stack>
										<Flex w="100%" borderBottomWidth={1} borderBottomColor="gray.700">
											<Text fontSize={18} fontWeight={500} color="gray.700">Permuta</Text>
										</Flex>

										<Flex
											w="100%"
											justify="space-between"
											alignItems="center"
											borderWidth={2}
											borderColor="gray.200"
											borderRadius={8}
											px={3} py={2}
										>
											<Stack direction="row" spacing={2} justify="center" align="center">
												<Image w="30" h="25" src={lancamentoJson.lancamentos[0].pay.url_pay} />
												<Text fontWeight={500}>{lancamentoJson.lancamentos[0].pay.name_pay}</Text>
											</Stack>

											<Stack direction="row" spacing={2} justify="center" align="center">
												<Text fontWeight={500}>
													{lancamentoJson.lancamentos[0].vlr_cred
														? formatPrice(lancamentoJson.lancamentos[0].vlr_cred) 
														: formatPrice(lancamentoJson.lancamentos[0].vlr_deb)
													}
												</Text>
											</Stack>
										</Flex>
									</Stack>
								)}

								<Stack w="100%" spacing={[0, 4]} mt={1} direction={['column', 'column', 'row']}>
									<button
										className={troco > 0 ? "button-cancel" : "button-save"}
										disabled={falta === 0 && troco === 0}
										onClick={() => setModalAddPagBaixaVisible(true)}
										style={{ padding: '5px 10px', marginLeft: '0px' }}
									>
										+ {troco > 0 ? "Troco" : "Pagamento"}
									</button>
								</Stack>

								<Stack w="100%" spacing={[0, 4]} mt={1} direction="column">
									{pagamentos.length > 0 ? (
										<SimpleGrid columns={1} spacing={2} w="100%" mt={2}>
											<Flex w="100%" borderBottomWidth={1} borderBottomColor="gray.700">
												<Text fontSize={18} fontWeight={500} color="gray.700">Pagamentos</Text>
											</Flex>

											{pagamentos.map(pagamento => {
												return (
													<Flex
														key={pagamento.id}
														w="100%"
														justify="space-between"
														alignItems="center"
														borderWidth={2}
														borderColor="gray.200"
														borderRadius={8}
														px={3} py={2}
													>
														<Stack direction="row" spacing={2} justify="center" align="center">
															<Image w="30" h="25" src={pagamento.pay.url_pay} />
															<Text fontWeight={500}>{pagamento.pay.name_pay}</Text>
														</Stack>

														<Stack direction="row" spacing={2} justify="center" align="center">
															<Text fontWeight={500}>{pagamento.qtd_parcelas}x {pagamento.valor}</Text>
															&nbsp;
															<Icon
																as={FiTrash2}
																fontSize={20}
																color="red.600"
																cursor="pointer"
																onClick={() => removePagBaixa(pagamento.id)}
															/>
														</Stack>
													</Flex>
												)
											})}
										</SimpleGrid>
									) : (
										<Flex w="100%" justify="center" py={2}>
											<Text fontWeight={500}>Nenhum Pagamento Adicionado</Text>
										</Flex>
									)}
								</Stack>

								{trocos.length > 0 && (
									<Stack w="100%" spacing={[0, 4]} mt={3} direction="column">
										<Flex w="100%" borderBottomWidth={1} borderBottomColor="red.800">
											<Text fontSize={18} fontWeight={500} color="red.800">Trocos</Text>
										</Flex>
										
										<SimpleGrid columns={1} spacing={2} w="100%" mt={2}>
											{trocos.map(troco => {
												return (
													<Flex
														key={troco.id}
														w="100%"
														justify="space-between"
														alignItems="center"
														borderWidth={2}
														borderColor="red.800"
														borderRadius={8}
														px={2} py={1}
													>
														<Flex justify="center">
															<Image w="30" h="25" src={troco.pay.url_pay} alt={troco.pay.url_pay} />
															&nbsp;&nbsp;
															<Text fontWeight={500}>{troco.pay.name_pay}</Text>
														</Flex>

														<Flex justify="center" align="center">
															<Text fontWeight={500}>{troco.valor}</Text>
															&nbsp;
															<Icon
																as={FiTrash2}
																fontSize={18}
																color="red.600"
																cursor="pointer"
																onClick={() => removeTrocoBaixa(troco.id)}
															/>
														</Flex>
													</Flex>
												)
											})}
										</SimpleGrid>
									</Stack>
								)}

								<Buttons>
									<Flex w="100%" justify="flex-start" flexDir="column" pl={4} py={0}>
										<Text fontSize={[12, 14]} fontWeight={400}>Usuário:</Text>
										<Text pl={2} fontSize={[13, 15]} fontWeight={500}>{user.nome}</Text>
									</Flex>

									<Flex className="buttons">
										<button
											type="button"
											className="button-cancel"
											onClick={() => {
												setTextAlert({
													header: 'Cancelar Baixa!',
													body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
													is_toast: true,
												});
												setOpenAlert(true);
											}}
										>
											Cancelar
										</button>

										<button
											type="submit"
											className="button-save"
											onClick={handleSubmitBaixa}
											disabled={falta > 0}
										>
											&nbsp;&nbsp;&nbsp;Próximo&nbsp;&nbsp;&nbsp;
										</button>
									</Flex>
								</Buttons>
							</TabPagamento>
						</TabPanels>
					</Tabs>
				</TabsView>
			</Content>

			{modalAddPagBaixaVisible && (
				<ModalAddPagBaixa
					isVisible={modalAddPagBaixaVisible}
					onClose={setModalAddPagBaixaVisible}
					baixa={baixa}
					pays={troco > 0 ? selectTrocos : selectPays}
					contas={selectContas}
					setPagamentos={setPagamentos}
					pagamentos={pagamentos}
					setFalta={setFalta}
					falta={falta}
					setTroco={setTroco}
					troco={troco}
					setTrocos={setTrocos}
					trocos={trocos}
					setLancamentoJson={setLancamentoJson}
					lancamentoJson={lancamentoJson}
					operacao={operacao}
				/>
			)}

			{modalPagPixVisible && (
				<ModalPagPix
					onClose={setModalPagPixVisible}
					isVisible={modalPagPixVisible}
					pix_params={pixParams}
				/>
			)}

			{openAlert && (
				<Alert
					isOpen={openAlert}
					onRequestClose={setOpenAlert}
					textAlert={textAlert}
					execFunction={handleCancel}
				/>
			)}
		</Container>
	);
};

export default ModalTituloBaixa;